/* eslint-disable no-cond-assign */
/* eslint-disable no-underscore-dangle */
// tslint:disable: no-conditional-assignment
import { Injectable } from '@angular/core';
import { Subject, Observable, of } from 'rxjs';
import { TicketProviderService } from './providers/ticket.provider.service';
import { map, catchError, switchMap } from 'rxjs/operators';
import { LocaleHelper } from 'src/locale/LocaleHelper';
import { UtilityService } from './util/utility.service';
import { EventVM } from '../models/event/event';
import { IPlayedTicket } from '../models/ticket/playedTicket';
import { ModelMapperService } from './util/model.mapper.service';
import { IBetOutcome } from '../models/bet/betOutcome.interface';
import { ITicketItemGroup } from '../models/ticket/ticketItemGroup.interface';
import { ICustomNotification } from '../models/notification/customNotification.interface';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { ErrorLevel, EventMappingType, MaxPayoutType, OddsValidationMode, RESTServiceMessage, ErrorType, TicketStatus, TicketRejectionReason, OfflineBetType, TicketType, RequestSource, TicketPlayType, FreeBetProcessingType, EventTypeBonusSetting, SportTreeCondition, MinimumEventOddMode, TypeOfPlaceBetTicket } from '../models/enums';
import { ConstantValues } from '../models/util/constantValues';
import { NotificationService } from './notification.service';
import { ITicketItemIdentifier } from '../models/ticket/ticketItemIdentfier.interface';
import { IBet } from '../models/bet/bet';
import { ITicketItem } from '../models/ticket/ticketItem.inerface';
import { IUpdateTicketRequestObjTO } from '../models/ticket/transportObjects/ubdateTicketRequestObjTO.interface';
import { OutcomeExclusionsService } from './outcomeExclusion.service';
import { IOddContainer } from '../components/ticket/oddContainer.interface';
import { ITicketOutcomeIdentifyer } from '../models/ticket/ticketOutcomeIdentifyer.interface';
import * as Combinatorics from 'js-combinatorics';
import { UserService } from './user.service';
import { ITicketValidationRequestTO } from '../models/ticket-validation/transportObjects/ticketValidationRequestTO.interface';
import { ITicket } from '../models/ticket/ticket.interface';
import { ITicketValidationResult } from '../models/ticket-validation/ticketValidationResult.interface';
import { ITicketConfirmationRequestTO } from '../models/ticket/transportObjects/ticketConfirmationRequest.interface';
import { INotificationDialogEventModel } from '../models/ticket-validation/notificationDialogEvent.interface';
import { IUpdatedTicketItem } from '../models/ticket-validation/updatedTicketItem.interface';
import { ITicketDialogModel } from '../models/ticket-validation/ticketDialogModel.interface';
import { StorageService } from './util/storage.service';
import { LoaderService } from './loader.service';
import { ITicketData } from '../models/ticket/ticketData.interface';
import { ITicketTO } from '../models/ticket/transportObjects/ticketTO.interface';
import { ITicketGroup } from '../models/ticket/ticketGroup.interface';
import { ISystemOption } from '../models/ticket/system-option.interface';
import { IFreeBetSetting } from '../models/settings/freeBetSetting.interface';
import { ITicketOrderingItem } from '../models/ticket/ticketOrderingItem';
import { IBonusSettings } from '../models/settings/bonusSettings.interface';
import { MessagingService } from './messaging.service';
import { ISellBetRequest } from '../models/jacktime/transportObjects/sellBetRequestTO.interface';
import { SettingsService } from './settings.service';
import { TaxCalculatorService } from './taxCalculator.service';
import { ViewConfigurations } from '../models/util/viewConfigurations';
import { TicketManagerUserService } from '../ticket-manager/services/ticketManagerUser.service';
import { ITicketPrintViewModel } from '../ticket-manager/models/print/ticketPrintViewModel.interface';
import { CacheService } from './cache.service';
import { GoogleAnalyticsService } from './google-analytics.service';
import { IWinningsPerHit } from '../models/ticket/winningsPerHit.interface';
import { AffiliateService } from '../ticket-manager/services/affiliate.service';
import { EventsService } from './events.service';
import { IEventSrc } from '../models/event/eventSrc.interface';
import { IBetOutcomeWithPlayableStatus } from '../models/ticket/outcomeWithPlayableStatus.interface';
import { ISellBetResponseTmTO } from 'src/app/models/ticket-validation/transportObjects/sellBetResponseTmTO.interface';
import { ISellBetResponseTO } from 'src/app/models/ticket-validation/transportObjects/sellBetResponseTO.interface';
import { ISellBetResponse } from '../models/ticket-validation/sellBetResponse.interface';
import { ISellBetResponseTm } from '../models/ticket-validation/sellBetResponseTm.interface';
import { environment } from 'src/environments/environment';


export const TICKETVIEWSOURCE = 1;
export const EVENTSVIEWSOURCE = 2;

@Injectable()
export class TicketService {
  ticketDataa: ITicketData = { bonus: 0, bonusPercent: 0 } as ITicketData;
  languageCulture: string;
  protected isMobileView = false;

  maxWinningsForTicketByMaxTotalOddSettings: number;
  private ticketItemGroupsInTicket: { [eventId: number]: ITicketItemGroup } = {};
  private sentOdds: { [betOutcomeId: number]: number } = {};

  private dialogModel: ITicketDialogModel;

  private _initialTicketPayin = ConstantValues.INITIAL_TOTAL_STAKE;

  private reloadLastFiveTicketsOrUpdateTicketSource = new Subject<number>();
  public reloadLastFiveTicketsOrUpdateTicket$ = this.reloadLastFiveTicketsOrUpdateTicketSource.asObservable();
  private ticketItemAddedRemovedSource = new Subject<ITicketItemIdentifier>();
  public ticketItemAddedRemoved$ = this.ticketItemAddedRemovedSource.asObservable();
  private placeBetClickedSource = new Subject<void>();
  public placeBetClicked$ = this.placeBetClickedSource.asObservable();
  private ticketPlayedSource = new Subject<{ ticket: ITicketPrintViewModel; fastTicketCode: string }>();
  public ticketPlayed$ = this.ticketPlayedSource.asObservable();
  private ticketDataUpdatedSource = new Subject<void>();
  public ticketDataUpdated$ = this.ticketDataUpdatedSource.asObservable();
  private oddsValidationChangedSource = new Subject<OddsValidationMode>();
  public oddsValidationChanged$ = this.oddsValidationChangedSource.asObservable();
  private editTicketItemSource = new Subject<{ ticketItemGroup: ITicketItemGroup; ticketItem: ITicketItem; editOutcome: boolean}>();
  public editTicketItem$ = this.editTicketItemSource.asObservable();

  private fastTicketOrStorageLoadedSource = new Subject<{ totalStake: number; fixedGroupEventIds?: number[]; systemGroupEventIds?: number[]; selectedEventsInCombinations?: number[] }>();
  public fastTicketOrStorageLoaded$ = this.fastTicketOrStorageLoadedSource.asObservable();

  private openTicketSource = new Subject<void>();
  public openTicket$ = this.openTicketSource.asObservable();

  private openMyTicketSource = new Subject<void>();
  public openMyTicket$ = this.openMyTicketSource.asObservable();

  private changedOddsAcceptedSource = new Subject<void>();
  public changedOddsAccepted$ = this.changedOddsAcceptedSource.asObservable();

  private minOddsSysEvIdsByOddLowToHiWithoutBankers?: { [eventId: number]: number };
  private maxOddsSysEvIdsByOddHiToLowWithoutBankers?: { [eventId: number]: number };

  private waitingForTicketResponse = false;

  private tempTicketDetailsToAdd: {
    ticketItemGroups: { [eventId: number]: ITicketItemGroup };
    totalStake?: number;
    fixedGroupEventIds?: number[];
    systemGroupEventIds?: number[];
    selectedEventsInCombinations?: number[];
    outcomesWithPlayableStatuses: IBetOutcomeWithPlayableStatus[];
  } = null;

  constructor(
    private modelMapper: ModelMapperService,
    private ticketProviderService: TicketProviderService,
    private notificationService: NotificationService,
    private exclusionsService: OutcomeExclusionsService,
    private userService: UserService,
    private utilityService: UtilityService,
    private storage: StorageService,
    private loaderService: LoaderService,
    private messagingService: MessagingService,
    private taxCalculator: TaxCalculatorService,
    private ticketManagerUserService: TicketManagerUserService,
    private cache: CacheService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private settingsService: SettingsService,
    private affiliateService: AffiliateService,
    private eventsService: EventsService
  ) {
    this.languageCulture = LocaleHelper.cultureName[storage.language];
    this.isMobileView = this.utilityService.mobileView;
    const ticketItemGroupsFromStorage = storage.ticketItemGroups;
    if (Object.keys(ticketItemGroupsFromStorage).length > 0) {
      this.addTicketItemsFromStorageOrFastTicket(ticketItemGroupsFromStorage);
    }
  }

  public get ticketDetailsToAddOnTicketCreate() {
    return this.tempTicketDetailsToAdd;
  }

  public set ticketDetailsToAddOnTicketCreate(detailsToAdd: {
    ticketItemGroups: { [eventId: number]: ITicketItemGroup };
    totalStake?: number;
    fixedGroupEventIds?: number[];
    systemGroupEventIds?: number[];
    selectedEventsInCombinations?: number[];
    outcomesWithPlayableStatuses: IBetOutcomeWithPlayableStatus[];
  }) {
    this.tempTicketDetailsToAdd = detailsToAdd;
    if (detailsToAdd?.totalStake) {
      this._initialTicketPayin = detailsToAdd.totalStake;
    }
  }




  public get minOddsSysEvIdsByOddLowToHighWithoutBankers() {
    return this.minOddsSysEvIdsByOddLowToHiWithoutBankers;
  }

  public set minOddsSysEvIdsByOddLowToHighWithoutBankers(minOddsSysEvIdsByOddLowToHiWithoutBankers: { [eventId: number]: number }) {
    this.minOddsSysEvIdsByOddLowToHiWithoutBankers = minOddsSysEvIdsByOddLowToHiWithoutBankers;
  }


  public get maxOddsSysEvIdsByOddHighToLowWithoutBankers() {
    return this.maxOddsSysEvIdsByOddHiToLowWithoutBankers;
  }

  public set maxOddsSysEvIdsByOddHighToLowWithoutBankers(maxOddsSysEvIdsByOddHiToLowWithoutBankers: { [eventId: number]: number }) {
    this.maxOddsSysEvIdsByOddHiToLowWithoutBankers = maxOddsSysEvIdsByOddHiToLowWithoutBankers;
  }
  // get oddsValidationMode(){
  //   return this.oddsValidation;
  // }

  get initialTicketPayin() {
    return this._initialTicketPayin;
  }

  set initialTicketPayin(payin: number) {
    this._initialTicketPayin = payin;
  }

  get ticketItemGroups() {
    return this.ticketItemGroupsInTicket;
  }

  public openTicket() {
    this.openTicketSource.next();
  }

  public openMyTicket() {
    this.openMyTicketSource.next();
  }

  updateTicketData(data: ITicketData) {
    this.ticketDataa = data;
    this.ticketDataUpdatedSource.next();
  }

  get ticketData(): ITicketData {
    return this.ticketDataa;
  }

  notifyOddsValidationChange(oddsValidation: OddsValidationMode) {
    this.oddsValidationChangedSource.next(oddsValidation);
  }

  notifyPlaceBetClicked() {
    this.placeBetClickedSource.next();
  }

  reloadLastFiveTicketsOrUpdateTicket(cashbackedTicketId: number = null) {
    this.reloadLastFiveTicketsOrUpdateTicketSource.next(cashbackedTicketId);
  }

  // getLastFiveTickets(userId: number, ticketStatus: number): Observable<IPlayedTicket[]> {
  //   return this.ticketProviderService.getLastFiveTickets(userId, ticketStatus)
  //     .pipe(
  //       map(playedTickets => playedTickets.map(playedTicket => this.modelMapper.mapPlayedTicket(playedTicket)))
  //     );
  // }

  getTicketsForDesktop(token: string, dateFrom: Date, dateTo: Date, filter: string): Observable<IPlayedTicket[]> {


    return this.getTicketsForMobile(token, environment.myTicketsCount, 0, dateFrom, dateTo, filter);

  }

  getTicketsForMobile(token: string, limit: number, offset: number, dateFrom: Date, dateTo: Date, filter: string): Observable<IPlayedTicket[]> {
    if (this.storage.affiliateJwtToken) {
      return this.settingsService.getBetTypeShowTypes().pipe(
        switchMap(betTypeShowTypes =>
          this.ticketProviderService.getTicketsForMobileAffiliate(this.storage.affiliate.affiliateId, limit, offset, dateFrom, dateTo, filter)
            .pipe(
              map(playedTickets =>
                playedTickets.map(playedTicket => this.modelMapper.mapPlayedTicket(playedTicket, betTypeShowTypes, null)
                )
              )
            )
        )
      );
    } else {
      return this.settingsService.getBetTypeShowTypes().pipe(
        switchMap(betTypeShowTypes =>
          this.ticketProviderService.getTicketsForMobile(token, limit, offset, dateFrom, dateTo, filter)
            .pipe(
              map(playedTickets =>
                playedTickets.map(playedTicket => this.modelMapper.mapPlayedTicket(playedTicket, betTypeShowTypes, null)
                )
              )
            )
        )
      );
    }
  }

  getCasheoutValue(ticketNumber: string, createdBy: number): Observable<number> {
    if (!this.storage.affiliate) {
      return of(0);
    }

    if (this.storage.affiliate.affiliateId !== createdBy) {
      return of(0);
    }

    return this.ticketProviderService.getCasheoutValue(ticketNumber).pipe(
      map(response => response ? response.payout : 0)
    );
  }

  sellBet(sellBetRequest: ISellBetRequest, isAffilaite: boolean): Observable<ISellBetResponseTm | ISellBetResponse> {
    return this.ticketProviderService.sellBet(sellBetRequest).pipe(
      map(sellBetResponse => {
        if (isAffilaite) {
          return this.modelMapper.mapSellBetResponseTM(sellBetResponse as ISellBetResponseTmTO);
        } else {
          return this.modelMapper.mapSellBetResponse(sellBetResponse as ISellBetResponseTO);
        }
      })
    );
  }

  openTicketConfirmation(
    oddsValidationMode: OddsValidationMode,
    ticketData: ITicketData,
    isFix: boolean,
    isMultiplayBanker?,
    isMultiplaySystem?,
    systemOptions?: ISystemOption[],
    placeBetType?: TypeOfPlaceBetTicket) {
    // call mapper where all be new created ticket is not needed on confirmation mapTicketDialogModelForConfirmation
    this.notificationService.forwardDataToTicketDialog(this.modelMapper.mapTicketDialogModelForConfirmation(
      this.ticketItemGroupsInTicket,
      TicketPlayType.PlaceBet,
      ticketData,
      isFix,
      this.minOddsSysEvIdsByOddLowToHiWithoutBankers,
      this.maxOddsSysEvIdsByOddHiToLowWithoutBankers,
      oddsValidationMode,
      isMultiplayBanker,
      isMultiplaySystem,
      systemOptions,
      placeBetType));
  }

  getTicketById(ticketId: number): Observable<IPlayedTicket> {
    return this.settingsService.getBetTypeShowTypes().pipe(
      switchMap(betTypeShowTypes =>
        this.ticketProviderService.getTicketById(ticketId).pipe(
          map(playedTicket => this.modelMapper.mapPlayedTicket(playedTicket, betTypeShowTypes, null))
        )
      )
    );
  }

  openTicketDetails(ticket: IPlayedTicket) {
    // get other data for ticket
    // if needed uncomment
    // this.getTicketById(ticket.id).subscribe(playedTicket => {
      // ticket.id = playedTicket.id;
      // ticket.ticketNumber = playedTicket.ticketNumber;
      // ticket.createdOn = playedTicket.createdOn;
      // ticket.numberOfMatches = playedTicket.numberOfMatches;
      // ticket.numberOfCombinations = playedTicket.numberOfCombinations;
      // ticket.type = playedTicket.type;
      // ticket.stake = playedTicket.stake;
      // ticket.possibleMinWin = playedTicket.possibleMinWin;
      // ticket.possibleMaxWin = playedTicket.possibleMaxWin;
      // ticket.totalOdd = playedTicket.totalOdd;
      // ticket.system = playedTicket.system;
      // ticket.bonus = playedTicket.bonus;
      // ticket.status = playedTicket.status;
      // ticket.events = playedTicket.events;
      // ticket.createdOnDate = playedTicket.createdOnDate;
      // ticket.createdOnTime = playedTicket.createdOnTime;
      // ticket.jackTimeId = playedTicket.jackTimeId;
      // ticket.payin = playedTicket.payin;
      // ticket.taxBeforeStake = playedTicket.taxBeforeStake;
      // ticket.possiblePayout = playedTicket.possiblePayout;
      // ticket.possibleMinPayout = playedTicket.possibleMinPayout;
      // ticket.taxOnWinning = playedTicket.taxOnWinning;
      // ticket.taxOnMinWinning = playedTicket.taxOnMinWinning;


      const dialogModel = this.modelMapper.mapTicketDialogModelFromPlayedTicket(ticket);
      const orderingForTicketItemGroups: ITicketOrderingItem[] = [];
      if (ViewConfigurations.showNumberOfHitsForTicketSystem && dialogModel.systemTicketItemGroups.length > 0) {

        const oddsMap: { [eventId: number]: number } = {};

        const minOddsMap: { [eventId: number]: number } = {};

        ticket.events.forEach(event => {
          const minAndMaxOddsForEvent = this.getMInAndMaxOddForEvent(event.id,
            Object.entries(dialogModel.ticketItemEventGroups[event.id].ticketItems).map(([k, ti]) => ({ outcomeId: ti.betOutcomeId, outcomeTypeId: ti.betTypeOutcomeId })),
            dialogModel.ticketItemEventGroups);
          oddsMap[event.id] = minAndMaxOddsForEvent.maxOdd;
          minOddsMap[event.id] = minAndMaxOddsForEvent.minOdd;
          const outcomeIds = event.outcomes.map(o => o.betOutcomeId);
          orderingForTicketItemGroups.push({ eventId: event.id, outcomeIds });

        });

        dialogModel.maxOddsSysEvIdsByOddHiToLowWithoutBankers = this.createmaxOddsSysEvIdsByOddHiToLowWithoutBankers(dialogModel.ticketItemEventGroups, dialogModel.bankerTicketItemGroups.map(be => be.eventId), oddsMap);
        dialogModel.minOddsSysEvIdsByOddLowToHiWithoutBankers = this.createminOddsSysEvIdsByOddLowToHiWithoutBankers(dialogModel.ticketItemEventGroups, dialogModel.bankerTicketItemGroups.map(be => be.eventId), minOddsMap);

      }

      if (dialogModel.systemTicketItemGroups?.length > 0 && dialogModel.systemName && !dialogModel.hasLiveItems && ViewConfigurations.showNumberOfHitsForTicketSystem) {
        const selSysOpts = dialogModel.systemName.substring(0, dialogModel.systemName.indexOf('/')).split(',').map(n => +n);
        if (dialogModel.bankerTicketItemGroups?.length > 0) {
          dialogModel.systemOptions = this.calculateMultiSystemOptions(dialogModel.isMultiplaySystem, dialogModel.isMultiplayBanker, dialogModel.systemTicketItemGroups, dialogModel.bankerTicketItemGroups);
        } else {
          dialogModel.systemOptions = this.calculateRegularSystemOptions(dialogModel.ticketItemEventGroups, orderingForTicketItemGroups, dialogModel.isMultiplaySystem, dialogModel.systemTicketItemGroups, dialogModel.bankerTicketItemGroups);
        }

        for (const sysOpt of dialogModel.systemOptions) {
          if (selSysOpts.includes(sysOpt.eventsInCombination)) {
            sysOpt.optionSelected = true;
          }
        }
      }

      this.notificationService.forwardDataToTicketDialog(dialogModel);
    // });
  }

  private notifyTicketItemAddedRemoved(ticketItemIdentifier: ITicketItemIdentifier) {
    this.ticketItemAddedRemovedSource.next(ticketItemIdentifier);
    this.cache.selectBetOutcomeFromTicket(ticketItemIdentifier);
  }

  toggleEventOutcome(event: EventVM, bet: IBet, outcome: IBetOutcome, betTypeOutcomeName: string, betTypeName: string) {
    if (this.ticketItemGroupsInTicket[event.id] && this.ticketItemGroupsInTicket[event.id].ticketItems[outcome.id]) {

      delete this.ticketItemGroupsInTicket[event.id].ticketItems[outcome.id];

      if (Object.keys(this.ticketItemGroupsInTicket[event.id].ticketItems).length === 0) {
        delete this.ticketItemGroupsInTicket[event.id];
      }

      this.storage.ticketItemGroups = this.ticketItemGroupsInTicket;

      this.notifyTicketItemAddedRemoved({
        eventId: event.id,
        betTypeId: outcome.betTypeId,
        betId: outcome.betId,
        betTypeOutcomeId: outcome.betTypeOutcomeId,
        betOutcomeId: outcome.id,
        isAdded: false,
        isLive: event.isLive
      });
    } else {
      const error: ICustomNotification = this.getErrorForAddingItemToTicket(event, outcome);
      if (error) {
        this.notificationService.forwardDataToNotification(error);
        return;
      }

      if (!this.ticketItemGroupsInTicket[event.id]) {
        this.ticketItemGroupsInTicket[event.id] = this.modelMapper.mapTicketItemGroup(event, this.languageCulture);
      }

      this.ticketItemGroupsInTicket[event.id].ticketItems[outcome.id] = this.modelMapper.mapTicketItem(event.eventType, bet, outcome, betTypeOutcomeName, betTypeName);

      this.storage.ticketItemGroups = this.ticketItemGroupsInTicket;
      this.notifyTicketItemAddedRemoved({
        eventId: event.id,
        betTypeId: outcome.betTypeId,
        betId: outcome.betId,
        betTypeOutcomeId: outcome.betTypeOutcomeId,
        betOutcomeId: outcome.id,
        isAdded: true,
        isLive: event.isLive
      });
    }
  }

  removeTicketItem(ticketItemGroup: ITicketItemGroup, ticketItem: ITicketItem) {
    if (this.ticketItemGroupsInTicket[ticketItemGroup.eventId] && this.ticketItemGroupsInTicket[ticketItemGroup.eventId].ticketItems[ticketItem.betOutcomeId]) {

      delete this.ticketItemGroupsInTicket[ticketItemGroup.eventId].ticketItems[ticketItem.betOutcomeId];

      if (Object.keys(this.ticketItemGroupsInTicket[ticketItemGroup.eventId].ticketItems).length === 0) {
        delete this.ticketItemGroupsInTicket[ticketItemGroup.eventId];
      }

      this.storage.ticketItemGroups = this.ticketItemGroupsInTicket;
      this.notifyTicketItemAddedRemoved({
        eventId: ticketItemGroup.eventId,
        betTypeId: ticketItem.betTypeId,
        betId: ticketItem.betId,
        betTypeOutcomeId: ticketItem.betTypeOutcomeId,
        betOutcomeId: ticketItem.betOutcomeId,
        isAdded: false,
        isLive: ticketItemGroup.isLive
      });
    }
  }

  public addExistingItemsToTicket() {
    for (const [key, group] of Object.entries(this.ticketItemGroupsInTicket)) {
      for (const [key, ticketItem] of Object.entries(group.ticketItems)) {
        this.notifyTicketItemAddedRemoved({
          eventId: group.eventId,
          betTypeId: ticketItem.betTypeId,
          betId: ticketItem.betId,
          betTypeOutcomeId: ticketItem.betTypeOutcomeId,
          betOutcomeId: ticketItem.betOutcomeId,
          isAdded: true,
          isLive: group.isLive
        });
      }
    }
  }

  addTicketItemsFromStorageOrFastTicket(ticketItemGroups: { [eventId: number]: ITicketItemGroup }, totalStake?: number, fixedGroupEventIds?: number[], systemGroupEventIds?: number[], selectedEventsInCombinations?: number[]) {
    this.getOutcomesWithPlayableStatuses(ticketItemGroups).subscribe((outcomesWithPlayableStatuses) => {
      this.reAddItemsToTicket(ticketItemGroups, outcomesWithPlayableStatuses, totalStake, fixedGroupEventIds, systemGroupEventIds, selectedEventsInCombinations);
    });
  }

  getOutcomesWithPlayableStatuses(ticketItemGroups: { [eventId: number]: ITicketItemGroup }): Observable<IBetOutcomeWithPlayableStatus[]> {
    const updateTicketRequest: IUpdateTicketRequestObjTO[] = [];
    Object.entries(ticketItemGroups).forEach(([key, group]) => {
      // wen pulled out of storage is string not date
      group.eventDateTime = new Date(group.eventDateTime.toString());
      Object.entries(group.ticketItems).forEach(([key, ticketItem]) => {
        updateTicketRequest.push(this.modelMapper.mapUpdateTicketRequestObjTO(group, ticketItem));
      });
    });
    if (updateTicketRequest.length === 0) {
      return of([]);
    }

    return this.ticketProviderService.getOutcomesWithPlayableStatuses(updateTicketRequest).pipe(
      map(outcomesWithPlayableStatusesTO => outcomesWithPlayableStatusesTO.map(owps => this.modelMapper.mapBetOutcomeWithPlayableStatus(owps, ticketItemGroups[owps.betOutcome.eventId].isLive)))
    );
  }

  public getNewItemStatusesForRebetAndAddToTicket(ticketItemGroups: { [eventId: number]: ITicketItemGroup }, fixedGroupEventIds: number[] , systemGroupEventIds: number[], isTicketFix: boolean, stake?: number, systemEventsInCombination: number[] = []){
    const updateTicketRequest: IUpdateTicketRequestObjTO[] = [];
    Object.entries(ticketItemGroups).forEach(([key, group]) => {
      // wen pulled out of storage is string not date
      group.eventDateTime = this.utilityService.convertStringToDate(String(group.eventDateTime) , 'rebet');
      Object.entries(group.ticketItems).forEach(([key, ticketItem]) => {
        updateTicketRequest.push(this.modelMapper.mapUpdateTicketRequestObjTO(group, ticketItem));
      });
    });
    if (updateTicketRequest.length === 0) {
      return;
    }

    this.ticketProviderService.getOutcomesWithPlayableStatuses(updateTicketRequest).subscribe(outcomesWithPlayableStatusesTO => {
      const outcomesWithPlayableStatuses: IBetOutcomeWithPlayableStatus[] = [];
      for (const outcomeWithPlayableStatusesTO of outcomesWithPlayableStatusesTO) {
        const outcomeWithPlayableStatuses = this.modelMapper.mapBetOutcomeWithPlayableStatus(outcomeWithPlayableStatusesTO, ticketItemGroups[outcomeWithPlayableStatusesTO.betOutcome.eventId].isLive);
        outcomesWithPlayableStatuses.push(outcomeWithPlayableStatuses);
        if (!outcomeWithPlayableStatuses.betOutcome.isLive && (outcomeWithPlayableStatuses.eventDateTime <= new Date())) {
          outcomeWithPlayableStatuses.isEventPlayable = false;
        }
      }
      const playableOutcomes = outcomesWithPlayableStatuses.filter(owps => owps.isBetPlayable && owps.isEventPlayable && owps.betOutcome.isPlayable);
      if (playableOutcomes.length === 0) {
        const notification = {
          title: DynamicTranslations.notification_title,
          message: 'There is no active events on this ticket.',
          errorLevel: ErrorLevel.Notification,
          errorType: ErrorType.CloseDialog,
        };
        this.notificationService.forwardDataToNotification(notification as ICustomNotification);
        return;
      }

      const offlineOutcomes = outcomesWithPlayableStatuses.filter(owps => !(owps.isBetPlayable && owps.isEventPlayable && owps.betOutcome.isPlayable));

      let systemEventsInCombinationn = systemEventsInCombination;

      // case when there is offline outcomes in ticket
      if (offlineOutcomes.length > 0) {
        const offlineBets: Array<INotificationDialogEventModel> = [];
        const notification = {
          title: DynamicTranslations.offlineBets_Error_title,
          message: DynamicTranslations.offlineBets_Error_errorMessage + ' Following items are not added:',
          errorLevel: ErrorLevel.Notification,
          errorType: ErrorType.CloseDialog,
          offlineBets
        };
        fixedGroupEventIds = [];
        systemGroupEventIds = [];
        for (const key in ticketItemGroups) {
          if (Object.prototype.hasOwnProperty.call(ticketItemGroups, key)) {
            const ticketItemGroup = ticketItemGroups[key];
            for (const key in ticketItemGroup.ticketItems) {
              if (Object.prototype.hasOwnProperty.call(ticketItemGroup.ticketItems, key)) {
                const ticketItem = ticketItemGroup.ticketItems[key];
                if (!playableOutcomes.find(o => o.betOutcome.id === ticketItem.betOutcomeId)) {
                  // const offlineOWps = offlineOutcomes.find(o => o.betOutcome.id === ticketItem.betOutcomeId);
                  offlineBets.push({
                    name: ticketItemGroup.eventHomeTeam + '-' + ticketItemGroup.eventAwayTeam,
                    sbv: ticketItem.sbv,
                    outcome: ticketItem.betOutcomeName,
                    betType: ticketItem.betTypeName,
                    offlineBetType: DynamicTranslations.offlineBets_Error_marketOffline
                    // offlineBetType: (offlineOWps && !offlineOWps.isEventPlayable) ? DynamicTranslations.offlineBets_Error_eventOffline : DynamicTranslations.offlineBets_Error_marketOffline
                  } as INotificationDialogEventModel);
                  delete ticketItemGroup.ticketItems[key];
                }
              }
            }

            if (Object.keys(ticketItemGroup.ticketItems).length === 0) {
              systemEventsInCombinationn = [];
              delete ticketItemGroups[key];
            } else {
              if (ticketItemGroup.isInBankersGroup || isTicketFix) {
                fixedGroupEventIds.push(ticketItemGroup.eventId);
              } else {
                systemGroupEventIds.push(ticketItemGroup.eventId);
              }
            }
          }
        }

        this.notificationService.forwardDataToNotification(notification as ICustomNotification);
      }

      // this.addGroupsToNewTicket(ticketItemGroups, outcomesWithPlayableStatuses);

      // USE CODE BELOW FOR EXACT TICKET COPY

      this.ticketDetailsToAddOnTicketCreate = {
        ticketItemGroups,
        totalStake: stake,
        fixedGroupEventIds,
        systemGroupEventIds,
        selectedEventsInCombinations: systemEventsInCombinationn,
        outcomesWithPlayableStatuses: playableOutcomes
      };

      this.reAddItemsToTicket(ticketItemGroups, outcomesWithPlayableStatuses, stake, fixedGroupEventIds, systemGroupEventIds, systemEventsInCombinationn);
      // Added because ticket onInit checking this field ticketDetailsToAddOnTicketCreate
      this.ticketDetailsToAddOnTicketCreate = null;
    });
  }


  reAddItemsToTicket(ticketItemGroups: { [eventId: number]: ITicketItemGroup }, outcomesWithPlayableStatuses: IBetOutcomeWithPlayableStatus[], totalStake?: number, fixedGroupEventIds?: number[], systemGroupEventIds?: number[], selectedEventsInCombinations?: number[]) {
    this.removeAllTicketItems();
    const ticketItemsToDelete: { eventId: number; betOutcomeId: number }[] = [];
    Object.entries(ticketItemGroups).forEach(([key, group]) => {
      // needs this way so view can manage to see its new propery changed
      if (Object.entries(group.ticketItems).length > 0) {
        this.ticketItemGroupsInTicket[group.eventId] = group;
      }
      Object.entries(group.ticketItems).forEach(([key, ticketItem]) => {
        const outcomeWithPlayableStatuses = outcomesWithPlayableStatuses.find((owps) => owps.betOutcome.id === ticketItem.betOutcomeId);
        if (outcomeWithPlayableStatuses) {
          group.eventDateTime = outcomeWithPlayableStatuses.eventDateTime;
          group.eventDate = group.eventDateTime.toLocaleDateString(this.languageCulture, this.utilityService.ticketItemGroupDateToStringFormat);
          group.eventTime = group.eventDateTime.toLocaleTimeString(this.languageCulture, { hour: 'numeric', minute: 'numeric' });
          group.eventDayShort = group.eventDateTime.toLocaleDateString(this.languageCulture, { weekday: 'short' });
          group.isEventPlayable = outcomeWithPlayableStatuses.isEventPlayable;
          if (!outcomeWithPlayableStatuses.betOutcome.isLive && (outcomeWithPlayableStatuses.eventDateTime <= new Date())) {
            group.isEventPlayable = false;
          }
          ticketItem.isBetPlayable = outcomeWithPlayableStatuses.isBetPlayable;
          ticketItem.oldOdd = ticketItem.oldOdd;
          ticketItem.odd = outcomeWithPlayableStatuses.betOutcome.odd;
          ticketItem.isBetOutcomePlayable = outcomeWithPlayableStatuses.betOutcome.isPlayable;
          this.notifyTicketItemAddedRemoved({
            eventId: group.eventId,
            betTypeId: ticketItem.betTypeId,
            betId: ticketItem.betId,
            betTypeOutcomeId: ticketItem.betTypeOutcomeId,
            betOutcomeId: ticketItem.betOutcomeId,
            isAdded: true,
            isLive: group.isLive
          });
        } else {
          ticketItemsToDelete.push({ eventId: group.eventId, betOutcomeId: ticketItem.betOutcomeId });
        }
      });
    });

    ticketItemsToDelete.forEach(ti => {
      delete this.ticketItemGroupsInTicket[ti.eventId].ticketItems[ti.betOutcomeId];
      if (Object.keys(this.ticketItemGroupsInTicket[ti.eventId].ticketItems).length === 0) {
        delete this.ticketItemGroupsInTicket[ti.eventId];
      }
    });

    this.storage.ticketItemGroups = this.ticketItemGroupsInTicket;

    this.fastTicketOrStorageLoadedSource.next({ totalStake, fixedGroupEventIds, systemGroupEventIds, selectedEventsInCombinations });
  }

  isOutcomeInTicket(eventId: number, betOutcomeId: number): boolean {
    if (this.ticketItemGroupsInTicket[eventId]?.ticketItems[betOutcomeId]) {
      return true;
    }
    return false;
  }

  removeTicketItemGroup(group: ITicketItemGroup) {
    const list = Object.keys(group.ticketItems);
    list.forEach((key) => {
      this.removeTicketItem(group, group.ticketItems[key]);
      // DO IT LATER isLastOutcomeInEvent should be is whole event removed and than when notify is done dont recalculare every time only after whole event is removed
      //   if (i == 1) {
      //     isLastOutcomeInEvent = true;
      // }
      // this.removeItem(event.ticketItems[i - 1], isLastOutcomeInEvent);
    });
  }

  removeAllTicketItems() {
    const list = Object.keys(this.ticketItemGroups);
    list.forEach((key) => {
      this.removeTicketItemGroup(this.ticketItemGroups[key]);
    });
  }
  // Gets the odd for the given event and outcome.
  // private getOdd(eventId: number, outcomeId: number): number {
  //   // TODO implement appropriate data structures that will support this search.
  //   const index = this.ticketItems.findIndex(ti => ti.eventID === eventId && ti.betOutcomeId === outcomeId);

  //   return this.ticketItems[index].acceptedOdd;
  // }

  private getErrorForAddingItemToTicket(event: EventVM, outcome: IBetOutcome): ICustomNotification {
    // max multi events reached
    const isEventInTicket: boolean = outcome.eventId in this.ticketItemGroupsInTicket;
    let eventsInTicketCount = 0;
    let ticketItemsCount = 0;
    Object.entries(this.ticketItemGroupsInTicket).forEach(([, ticketItemGroup]) => {
      eventsInTicketCount++;
      ticketItemsCount += Object.keys(ticketItemGroup.ticketItems).length;
    });

    const notification = {
      message: null,
      title: DynamicTranslations.ticket_Error_title_errorAddingEvent,
      errorLevel: ErrorLevel.Notification
    } as ICustomNotification;

    if (event.mappingType === EventMappingType.SuperBetEvent && isEventInTicket) {
      notification.message = DynamicTranslations.ticketValidation_superBetMultiwaysNotAllowed;
      return notification;
    }

    if ((eventsInTicketCount < ticketItemsCount && eventsInTicketCount >= ConstantValues.MAX_MULTI_EVENTS_IN_TICKET && !isEventInTicket)
      || (eventsInTicketCount > ConstantValues.MAX_MULTI_EVENTS_IN_TICKET && isEventInTicket)) {
      notification.message = DynamicTranslations.ticket_Error_maxMultiwayEventsInTicket_ErrorMessage + ConstantValues.MAX_MULTI_EVENTS_IN_TICKET;
      return notification;
    }

    if (eventsInTicketCount >= ConstantValues.MAX_EVENTS_IN_TICKET && !this.ticketItemGroupsInTicket[event.id]) {
      notification.message = DynamicTranslations.ticket_Error_maxEventsInTicket_ErrorMessage + ConstantValues.MAX_EVENTS_IN_TICKET;
      return notification;
    }

    if (isEventInTicket && Object.keys(this.ticketItemGroupsInTicket[outcome.eventId].ticketItems).length >= ConstantValues.MAX_OUTCOMES_IN_EVENT) {
      notification.message = DynamicTranslations.ticket_Error_maxMultiwayOutcomesInEvent_ErrorMessage + ConstantValues.MAX_OUTCOMES_IN_EVENT;
      return notification;
    }

    if (event.siblingdEventId in this.ticketItemGroupsInTicket || Object.entries(this.ticketItemGroups).findIndex(([k, v]) => v.siblingEventId === event.id) > -1) {
      notification.message = DynamicTranslations.ticketValidation_cannotMixSuperBetEventAndStandardEvent;
      return notification;
    }


    let superbetEventsInTicketCount = 0;
    Object.entries(this.ticketItemGroupsInTicket).forEach(([, ticketItemGroup]) => {
      if (ticketItemGroup.mappingType === EventMappingType.SuperBetEvent) {
        superbetEventsInTicketCount++;
      }
    });

    if (event.mappingType === EventMappingType.SuperBetEvent && superbetEventsInTicketCount >= ConstantValues.SUPER_BET_MAX_SB_TICKETITEMS) {
      notification.message = DynamicTranslations.ticketValidation_superBetItemsCountHigherThanMaximumAllowed + ' ' + ConstantValues.SUPER_BET_MAX_SB_TICKETITEMS + ' ' + DynamicTranslations.ticketValidation_superBetItemsCountHigherThanMaximumAllowedPart2 + '.';
      return notification;
    }
    return null;
  }

  getMaxWinningsByBussinesModel(totalStake: number): number {
    if (ConstantValues.MAX_PAYOUT_TYPE === MaxPayoutType.MaxTotalOdd) {

      this.maxWinningsForTicketByMaxTotalOddSettings = ConstantValues.MAX_TOTAL_ODD * totalStake;
      if (this.maxWinningsForTicketByMaxTotalOddSettings > ConstantValues.MAX_PAY_OUT) {
        this.maxWinningsForTicketByMaxTotalOddSettings = ConstantValues.MAX_PAY_OUT + totalStake;

      }
      return this.maxWinningsForTicketByMaxTotalOddSettings;
    } else {
      return ConstantValues.MAX_PAY_OUT;
    }
  }

  public getMInAndMaxOddForEvent(eventId: number, outcomes: ITicketOutcomeIdentifyer[], ticketItemGroups: { [eventId: number]: ITicketItemGroup }): IOddContainer {
    let maxOdd = 0;
    let minOdd = Number.MAX_VALUE;

    // If all outcomes are possible, than there's no need to develope the whole system
    // and the max odds for such event is sum of odds for all played outcomes
    if (this.exclusionsService.checkIfCombinationIsPossible(outcomes)) {
      outcomes.forEach((outcome) => {
        const odd = this.getOdd(eventId, outcome.outcomeId, ticketItemGroups);
        maxOdd += odd;
        if (odd < minOdd) {
          minOdd = odd;
        }
      });
    } else {
      // If all outcomes are not possible, we must find the combination
      // of outcomes with best odsd.

      // 1. Calculate all combinations of outcomes
      const allCombinations: ITicketOutcomeIdentifyer[][] = this.getAllCombinations(outcomes);
      // let bestCombination: number[] = [];

      // 2. Iterate through all combinations and find maximal value
      for (const currentCombination of allCombinations) {
        // }
        // for (let i = 0; i < allCombinations.length; i++) {
        //   const currentCombination = allCombinations[i];

        // 2.1 Calculate the odds only if the combination is possible
        if (this.exclusionsService.checkIfCombinationIsPossible(currentCombination)) {
          let combinationOdd = 0;
          currentCombination.forEach((outcome) => {
            combinationOdd += this.getOdd(eventId, outcome.outcomeId, ticketItemGroups);
          });

          // 2.2 If the odds for current combination is bigger than the current
          // best odds, set it as new best odds and remember the combination.
          if (combinationOdd > maxOdd) {
            maxOdd = combinationOdd;
            // bestCombination = currentCombination;
          }

          // 2.3 If the odds for current combination is smaller then min odd
          // set min odd
          if (combinationOdd < minOdd) {
            minOdd = combinationOdd;
          }
        }
      }
    }

    const eventOdd: IOddContainer = { maxOdd: 1, minOdd: 1 };
    eventOdd.maxOdd = maxOdd;

    if (minOdd === Number.MAX_VALUE) {
      minOdd = maxOdd;
    }

    eventOdd.minOdd = minOdd;


    return eventOdd;
  }

  // notyfyOddAndWinningsChange(tOdd: number = 0, tWinnings: number = 0, tBonus: number = 0, minOdd: number = 0, minWinings: number = 0): void {
  //   this.oddAndWinningChangedSource.next({ totalOdd: tOdd, totalWinnings: tWinnings, bonus: tBonus, minOdd, minWinings });
  // }

  // Gets all the combinations (sizes 1 to n-1, where n is number of outcomes).
  private getAllCombinations(outcomes: ITicketOutcomeIdentifyer[]): ITicketOutcomeIdentifyer[][] {
    const allCombinations: ITicketOutcomeIdentifyer[][] = [];
    // little optimization
    const combo = Combinatorics.power<ITicketOutcomeIdentifyer>(outcomes);
    combo.forEach((cmb) => { allCombinations.push(cmb); });
    allCombinations.splice(0, 1);

    return allCombinations;
  }

  ticketPlayedSuccessfully(confirmedTicket: ITicket, fastTicketCode?: string) {
    this.ticketPlayedSource.next({ticket: this.modelMapper.mapTicketPrint(confirmedTicket), fastTicketCode});

    this.initialTicketPayin = ConstantValues.INITIAL_TOTAL_STAKE;
    this.sentOdds = {};
  }

  // Gets the odd for the given event and outcome.
  private getOdd(eventId: number, outcomeId: number, ticketItemGroups: { [eventId: number]: ITicketItemGroup }): number {
    if (ticketItemGroups[eventId].ticketItems[outcomeId]) {
      return ticketItemGroups[eventId].ticketItems[outcomeId].odd;
    }
  }

  placeBet(oddsValidationMode: OddsValidationMode, ticket: ITicket, authorizedTicketConfirmation: boolean, receiveNotification: boolean) {
    if (this.waitingForTicketResponse) {
      return;
    }
    const request: ITicketValidationRequestTO = this.modelMapper.makeTicketValidationRequest(oddsValidationMode, ticket, authorizedTicketConfirmation, this.ticketManagerUserService.officeId);
    this.loaderService.showHideLoader(true);
    this.waitingForTicketResponse = true;
    return this.settingsService.getBetTypeShowTypes().pipe(
      switchMap(betTypeShowTypes =>
        this.ticketProviderService.placeBet(request, this.ticketManagerUserService.user && this.ticketManagerUserService.user.isC).pipe(
          map((result) => this.modelMapper.mapTicketValidationResult(
            result,
            this.ticketManagerUserService.officeId,
            betTypeShowTypes))
        ))).subscribe(r => {
          this.waitingForTicketResponse = false;
          this.processTicketValidationRespose(r, receiveNotification, true, request.ticket.isFreeBet);
        });
  }

  placeBetWithRequest(request: ITicketValidationRequestTO, dialogModel: ITicketDialogModel, receiveNotification: boolean) {
    if (this.waitingForTicketResponse) {
      return;
    }
    this.waitingForTicketResponse = true;
    this.dialogModel = dialogModel;
    this.saveSentOdds(request.ticket);
    this.loaderService.showHideLoader(true);
    return this.settingsService.getBetTypeShowTypes().pipe(
      switchMap(betTypeShowTypes =>
        this.ticketProviderService.placeBet(request, this.ticketManagerUserService.user && this.ticketManagerUserService.user.isC).pipe(
          map((result) => this.modelMapper.mapTicketValidationResult(result, this.ticketManagerUserService.officeId, betTypeShowTypes))
        ))).subscribe(r => {
          this.waitingForTicketResponse = false;
          this.processTicketValidationRespose(r, receiveNotification, true, request.ticket.isFreeBet);
        });
  }

  // dont call from component for later
  placeFastBet(oddsValidationMode: OddsValidationMode, ticket: ITicket, authorizedTicketConfirmation: boolean, dialogModel: ITicketDialogModel, receiveNotification: boolean) {
    if (this.waitingForTicketResponse) {
      return;
    }
    this.waitingForTicketResponse = true;
    this.dialogModel = dialogModel;
    const request: ITicketValidationRequestTO = this.modelMapper.makeTicketValidationRequest(oddsValidationMode, ticket, authorizedTicketConfirmation, this.ticketManagerUserService.officeId);
    this.loaderService.showHideLoader(true);
    return this.settingsService.getBetTypeShowTypes().pipe(
      switchMap(betTypeShowTypes => this.ticketProviderService.placeFastBet(request).pipe(
        map((result) => this.modelMapper.mapTicketValidationResult(result, this.ticketManagerUserService.officeId, betTypeShowTypes))
      ))).subscribe(r => {
        this.waitingForTicketResponse = false;
        this.processTicketValidationRespose(r, receiveNotification);
      });
  }

  cancelTicket(confirmationTicket: ITicket) {
    this.dialogModel = null;
    this.sentOdds = {};
    return this.ticketProviderService.cancelTicket(this.modelMapper.makeTicketConfirmationRequestTO(confirmationTicket, this.ticketManagerUserService.officeId)).subscribe();
  }

  // ako pukne pingaj drugu
  checkTicket(confirmRequest: ITicketConfirmationRequestTO): Observable<ITicketValidationResult> {
    this.storage.ticketValidationId = confirmRequest.ticketValidationId;
    this.storage.dialogModel = this.dialogModel;
    return this.settingsService.getBetTypeShowTypes().pipe(
      switchMap(betTypeShowTypes => this.ticketProviderService.checkTicket(confirmRequest).pipe(
        map(r => {
          this.storage.ticketValidationId = null;
          this.storage.dialogModel = null;
          return this.modelMapper.mapTicketValidationResult(r, this.ticketManagerUserService.officeId, betTypeShowTypes);
        }),
        catchError(
          (err) => {
            this.checkTicketPing(false);
            return of(null);
          })
      )
      )
    );
  }

  searchPlayerTicket(ticketNumber: string, code: string): Observable<IPlayedTicket> {
    return this.settingsService.getBetTypeShowTypes().pipe(
      switchMap(betTypeShowTypes => this.ticketProviderService.searchPlayerTicket(ticketNumber, code).pipe(
        map(r => {
          if (r) {
            return this.modelMapper.mapPlayedTicket(r, betTypeShowTypes, this.storage.affiliate.affiliateId);
          } else {
            return null;
          }
        })
      )
      )
    );
  }

  processTicketValidationRespose(tc: ITicketValidationResult, receiveNotification: boolean, hideLoader: boolean = true, isFreebetTicket: boolean = false) {
    if (hideLoader) {
      this.loaderService.showHideLoader(false);
    }

    const notification: ICustomNotification = {
      errorLevel: ErrorLevel.Notification
    } as ICustomNotification;

    if (tc != null) {
      if (!tc.remoteOperationResult.success) {
        this.dialogModel = null;
        switch (tc.remoteOperationResult.restServiceMessage) {
          case RESTServiceMessage.PlatformError:
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = tc.remoteOperationResult.message;
            this.notificationService.forwardDataToNotification(notification);
            break;
          case RESTServiceMessage.Exception:
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = DynamicTranslations.ticketValidation_Exception;
            this.notificationService.forwardDataToNotification(notification);
            break;
          case RESTServiceMessage.TicketSinglesOnlyRestrictionsFailedForSport:
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = DynamicTranslations.ticketValidation_restrictionsFailedForSport + tc.remoteOperationResult.message;
            this.notificationService.forwardDataToNotification(notification);
            break;

          case RESTServiceMessage.TicketSinglesOnlyRestrictionsFailedForRegion:
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = DynamicTranslations.ticketValidation_restrictionsFailedForRegion + tc.remoteOperationResult.message;
            this.notificationService.forwardDataToNotification(notification);
            break;
          case RESTServiceMessage.TicketSinglesOnlyRestrictionsFailedForComptition:
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = DynamicTranslations.ticketValidation_restrictionsFailedForCompetition + tc.remoteOperationResult.message;
            this.notificationService.forwardDataToNotification(notification);
            break;
          case RESTServiceMessage.TicketSinglesOnlyRestrictionsFailedForEvent:
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = DynamicTranslations.ticketValidation_restrictionsFailedForEvent + tc.remoteOperationResult.message;
            this.notificationService.forwardDataToNotification(notification);
            break;
          case RESTServiceMessage.InsufficientFunds:
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = DynamicTranslations.ticketValidation_insufficientFunds_ErrorMessage;
            this.notificationService.forwardDataToNotification(notification);
            break;

          case RESTServiceMessage.MinSelection:
            const msg: string[] = tc.remoteOperationResult.message.split('|');
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = DynamicTranslations.ticketValidation_minSelectionReject + ' '
              + msg[1] + ' ' + DynamicTranslations.otherTranslations_partials_is + ': ' + msg[0];
            this.notificationService.forwardDataToNotification(notification);
            break;

          case RESTServiceMessage.MaxLeagueSelection:
            const ms: string[] = tc.remoteOperationResult.message.split('|');
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = DynamicTranslations.ticketValidation_maxLeagueSelectionReject + ' '
              + ms[1] + ' ' + DynamicTranslations.otherTranslations_partials_is + ': ' + ms[0];
            this.notificationService.forwardDataToNotification(notification);
            break;

          case RESTServiceMessage.InvalidTicketStatus:
            if (tc.validatedTicket.ticketValidationState.ticketStatus === TicketStatus.Rejected) {
              switch (tc.validatedTicket.ticketValidationState.ticketRejectionReason) {
                case TicketRejectionReason.LimitRiskRejection:
                  notification.message = DynamicTranslations.ticketValidation_riskLimitRejection_ErrorMessage;
                  if (tc.validatedTicket.ticketValidationState.maxStake <= 0) {
                    if (tc.validatedTicket.ticketValidationState.offlineBets != null) {
                      notification.message = notification.message + ' ' + DynamicTranslations.ticketValidation_liabilityReject;
                      tc.validatedTicket.ticketValidationState.offlineBets = tc.validatedTicket.ticketValidationState.offlineBets.filter(
                        (bet, index, bets) =>
                          bets.findIndex((b) => b.betOutcomeId === bet.betOutcomeId
                            && b.eventId === bet.eventId
                            && b.offlineBetType === bet.offlineBetType) === index);
                      const offlineBets: Array<INotificationDialogEventModel> = tc.validatedTicket.ticketValidationState.offlineBets.map<INotificationDialogEventModel>(b => ({
                        name: b.eventShortName,
                        sbv: b.specialBetValue,
                        outcome: b.betTypeOutcomeShortName,
                        betType: b.betTypeShortName,
                        offlineBetType: b.offlineBetType === OfflineBetType.EventOffline ? DynamicTranslations.offlineBets_Error_eventOffline : DynamicTranslations.offlineBets_Error_marketOffline
                      } as INotificationDialogEventModel));

                      notification.offlineBets = offlineBets;
                    }
                  }
                  else {
                    const stakeToShow = tc.validatedTicket.ticketValidationState.maxStake ? this.utilityService.roundByBusinessModel(tc.validatedTicket.ticketValidationState.maxStake) : tc.validatedTicket.ticketValidationState.maxStake;
                    notification.message = notification.message + ' ' + DynamicTranslations.ticketValidation_maxStake + stakeToShow;
                  }

                  notification.errorType = ErrorType.CloseDialog;
                  this.notificationService.forwardDataToNotification(notification);
                  break;

                case TicketRejectionReason.OfflineBets:
                  notification.errorType = ErrorType.CloseDialog;
                  notification.title = DynamicTranslations.offlineBets_Error_title;
                  notification.message = DynamicTranslations.offlineBets_Error_errorMessage;
                  tc.validatedTicket.ticketValidationState.offlineBets = tc.validatedTicket.ticketValidationState.offlineBets.filter(
                    (bet, index, bets) =>
                      bets.findIndex((b) => b.betOutcomeId === bet.betOutcomeId
                        && b.eventId === bet.eventId
                        && b.offlineBetType === bet.offlineBetType) === index);
                  const offlineBets: Array<INotificationDialogEventModel> = tc.validatedTicket.ticketValidationState.offlineBets.map<INotificationDialogEventModel>(b => ({
                    name: b.eventShortName,
                    sbv: b.specialBetValue,
                    outcome: b.betTypeOutcomeShortName,
                    betType: b.betTypeShortName,
                    offlineBetType: b.offlineBetType === OfflineBetType.EventOffline ? DynamicTranslations.offlineBets_Error_eventOffline : DynamicTranslations.offlineBets_Error_marketOffline
                  } as INotificationDialogEventModel));
                  notification.offlineBets = offlineBets;
                  this.notificationService.forwardDataToNotification(notification);
                  break;
                case TicketRejectionReason.ClientServerCalculationsDiffer:
                  notification.errorType = ErrorType.CloseDialog;
                  notification.title = DynamicTranslations.ticketValidation_title;
                  notification.message = tc.validatedTicket.ticketValidationState.ticketMessage;
                  this.notificationService.forwardDataToNotification(notification);
                  break;

                case TicketRejectionReason.RestrictionValidationFailed:
                  notification.errorType = ErrorType.CloseDialog;
                  notification.title = DynamicTranslations.ticketValidation_title;
                  notification.restictedItems = tc.validatedTicket.ticketValidationState.restrictedItems;
                  notification.message = DynamicTranslations.eventRestriction_errorMessage;
                  this.notificationService.forwardDataToNotification(notification);
                  break;

                case TicketRejectionReason.BetCloneRejected:
                  notification.errorType = ErrorType.CloseDialog;
                  notification.title = DynamicTranslations.ticketValidation_title;
                  notification.message = DynamicTranslations.ticketValidation_betCloneRejected;
                  this.notificationService.forwardDataToNotification(notification);
                  break;

                default:
                  notification.errorType = ErrorType.CloseDialog;
                  notification.message = DynamicTranslations.ticketValidation_cannotProcessTicket;
                  this.notificationService.forwardDataToNotification(notification);
                  break;
              }
            }
            break;

          case RESTServiceMessage.MaxEventsOnBetslipFailed:
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = DynamicTranslations.ticketValidation_maxEventsOnBetslipFailed + tc.remoteOperationResult.message;
            this.notificationService.forwardDataToNotification(notification);
            break;

          case RESTServiceMessage.MinStakePerBetslipFailed:
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = DynamicTranslations.ticketValidation_minStakePerBetslipFailed + tc.remoteOperationResult.message;
            this.notificationService.forwardDataToNotification(notification);
            break;

          case RESTServiceMessage.MinStakePerCombinationFailed:
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = DynamicTranslations.ticketValidation_minStakePerCombinationFailed + tc.remoteOperationResult.message;
            this.notificationService.forwardDataToNotification(notification);
            break;

          case RESTServiceMessage.TicketAutomaticallyRejected:
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            if (tc.validatedTicket && tc.validatedTicket.isMts) {
              notification.message = DynamicTranslations.ticketValidation_mtsRejection_ErrorMessage;
            } else {
              notification.message = DynamicTranslations.ticketValidation_riskLimitRejection_ErrorMessage;
            }
            this.notificationService.forwardDataToNotification(notification);
            break;

          case RESTServiceMessage.MaxTotalOdd:
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = DynamicTranslations.ticketValidation_maxTotalOdd + tc.remoteOperationResult.message;
            this.notificationService.forwardDataToNotification(notification);
            break;

          case RESTServiceMessage.MaxEventsInCombination:
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = DynamicTranslations.ticketValidation_maxEventsInCombination + tc.remoteOperationResult.message;
            this.notificationService.forwardDataToNotification(notification);
            break;

          case RESTServiceMessage.MaxStake:
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = DynamicTranslations.ticketValidation_maxStake + tc.remoteOperationResult.message;
            this.notificationService.forwardDataToNotification(notification);
            break;
          case RESTServiceMessage.UserDoesntHavePermissions:
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = DynamicTranslations.ticketValidation_inactiveUser;
            this.notificationService.forwardDataToNotification(notification);
            break;
          case RESTServiceMessage.TicketNotVerified:
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = DynamicTranslations.ticketValidation_cannotProcessTicket;
            this.notificationService.forwardDataToNotification(notification);
            break;
          case RESTServiceMessage.FreeBetConditionsAreNotFulfilled:
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            notification.message = DynamicTranslations.ticketValidation_freeBetConditionNotFulfilled;
            this.notificationService.forwardDataToNotification(notification);
            break;
          case RESTServiceMessage.SuperBetConditionsAreNotFulfilled:
            notification.errorType = ErrorType.CloseDialog;
            notification.title = DynamicTranslations.ticketValidation_title;
            if (tc.remoteOperationResult.message.includes('RES_MissingSuperBetSettings')) {
              notification.message = DynamicTranslations.ticketValidation_missingSuperBetSettings;
            } else if (tc.remoteOperationResult.message.includes('RES_SuperBetItemsCountHigherThanMaximumAllowed')) {
              notification.message = DynamicTranslations.ticketValidation_superBetItemsCountHigherThanMaximumAllowed;
              const spltStr = tc.remoteOperationResult.message.split(' ');
              const num = spltStr[1] ? spltStr[1] : '';
              notification.message += ' ' + num + ' ' + DynamicTranslations.ticketValidation_superBetItemsCountHigherThanMaximumAllowedPart2 + '.';

            } else if (tc.remoteOperationResult.message.includes('RES_CannotMixSuperBetEventAndStandardEvent')) {
              notification.message = DynamicTranslations.ticketValidation_cannotMixSuperBetEventAndStandardEvent;
            } else if (tc.remoteOperationResult.message.includes('RES_SuperBetMultiwaysNotAllowed')) {
              notification.message = DynamicTranslations.ticketValidation_superBetMultiwaysNotAllowed;
            } else if (tc.remoteOperationResult.message.includes('RES_NonSuperBetItemsOddLowerThanMinimumAllowed')) {
              const spltStr = tc.remoteOperationResult.message.split(' ');
              const num = spltStr[1] ? spltStr[1] : '';
              notification.message = DynamicTranslations.ticketValidation_NonSuperBetItemsOddLowerThanMinimumAllowed + ' ' + num + ' .';
            } else if (tc.remoteOperationResult.message.includes('RES_NonSuperBetItemsCountLowerThanAllowed')) {
              notification.message = DynamicTranslations.ticketValidation_nonSuperBetItemsCountLowerThanAllowed;
              const spltStr = tc.remoteOperationResult.message.split(' ');
              const num = spltStr[1] ? spltStr[1] : '';
              notification.message += ' ' + num + ' ' + DynamicTranslations.ticketValidation_nonSuperBetItemsCountLowerThanAllowedPart2 + '.';
            } else if (tc.remoteOperationResult.message.includes('RES_SUPERBET_ODD_LOWER_THEN_MINIMUM')) {
              const spltStr = tc.remoteOperationResult.message.split(' ');
              const numberOfEvents = spltStr[1] ? spltStr[1] : '';
              const odd = spltStr[2] ? spltStr[2] : '';
              notification.message = DynamicTranslations.ticketValidation_NonSuperBetItemsOddAndNumberLowerThanMinimumAllowedPart1 + ' ' + numberOfEvents + ' ' + DynamicTranslations.ticketValidation_NonSuperBetItemsOddAndNumberLowerThanMinimumAllowedPart2 + ' ' + odd;
            }
            this.notificationService.forwardDataToNotification(notification);
            break;

          default:
            if (tc.remoteOperationResult.message != null && tc.remoteOperationResult.message !== '') {
              notification.errorType = ErrorType.CloseDialog;
              notification.title = DynamicTranslations.ticketValidation_title;
              notification.message = tc.remoteOperationResult.message;
              this.notificationService.forwardDataToNotification(notification);
            } else {
              notification.errorType = ErrorType.CloseDialog;
              notification.title = DynamicTranslations.ticketValidation_title;
              notification.message = DynamicTranslations.ticketValidation_cannotProcessTicket;
              this.notificationService.forwardDataToNotification(notification);
            }
        }

      } else {
        if (this.storage.affiliate) {
          this.affiliateService.getAffiliateBalanceByAffiliateId(this.storage.affiliate.affiliateId).subscribe(x => {});
        } else {
          this.userService.getNewBalancesFromServer();
        }
        if (tc.validatedTicket.ticketValidationState.ticketStatus === TicketStatus.Pending) {
          // pozovi funkciju za slanje i prosledi u nju ovo  *(ITicketItemGroup[])
          // commneted because notifications are not redy for deploy
          // this.messagingService.sendITicketItemGroupsForMessaging(Object.entries(this.dialogModel.ticketItemEventGroups).map(([k, v]) => v), receiveNotification);
          if (isFreebetTicket) {
            if (this.dialogModel) {

              this.googleAnalyticsService.eventEmitter('Uplata listića', 'Free bet listić”', Object.keys(this.dialogModel.ticketItemEventGroups).length.toString());
            }

            // if (this.dialogModel.systemTicketItemGroups.length > 0 && this.dialogModel.ticketData.numberOfBets > 1) {
            //   // sistem
            //   this.googleAnalyticsService.eventEmitter('Uplata listića', 'Free bet listić sistemski', Object.keys(this.dialogModel.ticketItemEventGroups).length.toString());
            // } else {
            //   // obican
            //   this.googleAnalyticsService.eventEmitter('Uplata listića', 'Free bet listić običan', Object.keys(this.dialogModel.ticketItemEventGroups).length.toString());
            // }
          } else {
            if (this.dialogModel?.systemTicketItemGroups?.length > 0 && this.dialogModel.ticketData.numberOfBets > 1) {
              // sistem
              this.googleAnalyticsService.eventEmitter('Uplata listića', 'web sistemski', Object.keys(this.dialogModel.ticketItemEventGroups).length.toString());
            } else {
              // obican
              if (this.dialogModel) {
                this.googleAnalyticsService.eventEmitter('Uplata listića', 'web običan', Object.keys(this.dialogModel?.ticketItemEventGroups).length.toString());
              }
            }

          }

          this.dialogModel = null;
          notification.errorType = ViewConfigurations.showMyTicketButtonOnPlayedTicket ? ErrorType.SucssefulyPlayedTicket : ErrorType.CloseDialog;
          if (ViewConfigurations.addPlayedLiveEventsToFavorite) {
            const eventSrcs: IEventSrc[] = [];

            for (const group of Object.values(this.ticketItemGroupsInTicket)) {
              if (group.isLive) {
                eventSrcs.push({
                  sportId: group.sportId,
                  regionId: group.regionId,
                  competitionId: group.competitionId,
                  eventId: group.eventId,
                  addedDate: new Date()
                });
              }
            }
            if (eventSrcs.length > 0) {
              this.eventsService.addItemsFromTicketToFavorites(eventSrcs, this.isMobileView);
            }
          }
          if (ViewConfigurations.removeTicektItemsAfterTicketIsPlayed) {
            this.removeAllTicketItems();
          }
          notification.errorLevel = ErrorLevel.Success;
          notification.title = DynamicTranslations.ticketValidation_title;
          notification.message = DynamicTranslations.ticketValidation_ticketAccepted_ErrorMessage;
          this.ticketPlayedSuccessfully(tc.confirmedTicket);
          this.notificationService.forwardDataToNotification(notification);
        } else if (tc.validatedTicket.ticketValidationState.ticketStatus === TicketStatus.ConditionallyApproved) {
          // this.startAcceptTimer(); stavi ovo u ticket dialog
          const ticketDialogModel: ITicketDialogModel = {} as ITicketDialogModel;
          ticketDialogModel.hasLiveItems = false;
          if (tc.confirmedTicket) {
            if (this.dialogModel) {
              ticketDialogModel.minOddsSysEvIdsByOddLowToHiWithoutBankers = this.dialogModel.minOddsSysEvIdsByOddLowToHiWithoutBankers;
              ticketDialogModel.maxOddsSysEvIdsByOddHiToLowWithoutBankers = this.dialogModel.maxOddsSysEvIdsByOddHiToLowWithoutBankers;
              ticketDialogModel.ticketItemsLength = this.dialogModel.ticketItemsLength;
              ticketDialogModel.isFix = this.dialogModel.isFix;
              ticketDialogModel.isMultiplayBanker = this.dialogModel.isMultiplayBanker;
              ticketDialogModel.isMultiplaySystem = this.dialogModel.isMultiplaySystem;
            }
            if (!ticketDialogModel.isFix) {
              ticketDialogModel.systemTicketItemGroups = [];
              ticketDialogModel.bankerTicketItemGroups = [];
            }
            ticketDialogModel.ticketType = TicketPlayType.ConfirmationTicket;
            ticketDialogModel.ticketItemEventGroups = {};
            ticketDialogModel.confirmationOrPlayedTicket = tc.confirmedTicket;

            if (ticketDialogModel.confirmationOrPlayedTicket.freeBetProcessingType) {
              ticketDialogModel.confirmationOrPlayedTicket.isFreeBet = true;
            }

            if (TicketType[ticketDialogModel.confirmationOrPlayedTicket.typeOfTicket]) {
              ticketDialogModel.confirmationOrPlayedTicket.ticketTypeName = DynamicTranslations['enumTranslations_' + TicketType[ticketDialogModel.confirmationOrPlayedTicket.typeOfTicket]];
            }
            ticketDialogModel.confirmationOrPlayedTicket.officeId = this.ticketManagerUserService.officeId;
            ticketDialogModel.confirmationOrPlayedTicket.possibleWinWithoutBonus = tc.confirmedTicket.possibleWin;
            ticketDialogModel.confirmationOrPlayedTicket.webPlatformCurrency = this.userService.user.userCurrency;
            ticketDialogModel.confirmationOrPlayedTicket.webPlatformLanguage = this.userService.user.userLanguage;
            ticketDialogModel.confirmationOrPlayedTicket.platformCustomerId = +this.userService.user.userName;
            ticketDialogModel.confirmationOrPlayedTicket.typeOfTicket = tc.confirmedTicket.typeOfTicket;

            ticketDialogModel.confirmationOrPlayedTicket.groups.forEach(gr => {
              // eslint-disable-next-line guard-for-in
              // tslint:disable-next-line:forin
              for (const key in gr.ticketItems) {
                if (gr.ticketItems.hasOwnProperty(key)) {
                  const ticketItem = gr.ticketItems[key];
                  if (ticketItem.isLive) {
                    ticketDialogModel.hasLiveItems = true;
                  }
                  // ticketItem.eventDateTime = new Date(ticketItem.eventDateTime.toString().replace('Z', '') + 'Z');
                  // // ticketItem.oldOdd = ticketItem.requestedOdd;
                  // ticketItem.isBetPlayable = true;
                  // ticketItem.isPlayable = true;
                  // ticketItem.isEventPlayable = true;
                  let sbv: any;
                  if (ticketItem.sbv) {
                    sbv = ticketItem.sbv;
                  } else if (ticketItem.betValues.length !== 0) {
                    if (ticketItem.betValues[0].value != null) {
                      sbv = ticketItem.betValues[0].value;
                    } else if (ticketItem.betValues[0].liveSpecialBetValue != null) {
                      sbv = ticketItem.betValues[0].liveSpecialBetValue;
                    } else {
                      sbv = null;
                    }
                  } else {
                    sbv = null;
                  }
                  ticketItem.sbv = sbv;
                  ticketItem.betTypeOutcomeName = ticketItem.betTypeOutcomeName;

                  if (!ticketDialogModel.ticketItemEventGroups[ticketItem.eventId]) {
                    ticketDialogModel.ticketItemEventGroups[ticketItem.eventId] = this.modelMapper.createTicketItemGroupFromTicketItemForTicket(ticketItem, this.languageCulture);
                    if (this.ticketItemGroups[ticketItem.eventId]) {
                      ticketDialogModel.ticketItemEventGroups[ticketItem.eventId].sportName = this.ticketItemGroups[ticketItem.eventId].sportName;
                      ticketDialogModel.ticketItemEventGroups[ticketItem.eventId].regionName = this.ticketItemGroups[ticketItem.eventId].regionName;
                      ticketDialogModel.ticketItemEventGroups[ticketItem.eventId].competitionName = this.ticketItemGroups[ticketItem.eventId].competitionName;
                      ticketDialogModel.ticketItemEventGroups[ticketItem.eventId].eventName = this.ticketItemGroups[ticketItem.eventId].eventName;
                      ticketDialogModel.ticketItemEventGroups[ticketItem.eventId].eventCode = this.ticketItemGroups[ticketItem.eventId].eventCode;
                      ticketDialogModel.ticketItemEventGroups[ticketItem.eventId].eventHomeTeam = this.ticketItemGroups[ticketItem.eventId].eventHomeTeam;
                      ticketDialogModel.ticketItemEventGroups[ticketItem.eventId].eventAwayTeam = this.ticketItemGroups[ticketItem.eventId].eventAwayTeam;
                    }

                    if (!ticketDialogModel.isFix) {
                      if (this.ticketItemGroups[ticketItem.eventId]) {
                        ticketDialogModel.ticketItemEventGroups[ticketItem.eventId].isInBankersGroup = this.dialogModel.ticketItemEventGroups[ticketItem.eventId].isInBankersGroup;
                        if (ticketDialogModel.ticketItemEventGroups[ticketItem.eventId].isInBankersGroup) {
                          ticketDialogModel.bankerTicketItemGroups.push(ticketDialogModel.ticketItemEventGroups[ticketItem.eventId]);
                        } else {
                          ticketDialogModel.systemTicketItemGroups.push(ticketDialogModel.ticketItemEventGroups[ticketItem.eventId]);
                        }
                      }
                      ticketDialogModel.systemOptions = this.dialogModel.systemOptions.map((sysOpt) => {
                        sysOpt.maxOdds = 1;
                        sysOpt.maxOdds = 1;
                        return sysOpt;
                      });
                    }
                  }

                  if (!ticketDialogModel.ticketItemEventGroups[ticketItem.eventId].ticketItems[ticketItem.betOutcomeId]) {
                    ticketDialogModel.ticketItemEventGroups[ticketItem.eventId].ticketItems[ticketItem.betOutcomeId] = this.modelMapper.createTicketItemFromTicketItemForTicket(ticketItem);
                    if (this.ticketItemGroups[ticketItem.eventId].ticketItems[ticketItem.betOutcomeId]) {

                      ticketDialogModel.ticketItemEventGroups[ticketItem.eventId].ticketItems[ticketItem.betOutcomeId].betTypeName = this.ticketItemGroups[ticketItem.eventId].ticketItems[ticketItem.betOutcomeId].betTypeName;
                      ticketDialogModel.ticketItemEventGroups[ticketItem.eventId].ticketItems[ticketItem.betOutcomeId].betOutcomeName = this.ticketItemGroups[ticketItem.eventId].ticketItems[ticketItem.betOutcomeId].betOutcomeName;
                    }
                  }

                  // for later this will be needed prob to get min and max odd
                  // let index = this.ticketItems.findIndex(x => x.betOutcomeId == ticketItem.betOutcomeId);
                  // this.ticketItems[index] = ticketItem;
                }
              }
            });

            ticketDialogModel.requestedStake = ticketDialogModel.confirmationOrPlayedTicket.requestedStake;
            ticketDialogModel.requestedPayIn = this.ticketData.payin;
            ticketDialogModel.requestedTotalOdd = ticketDialogModel.confirmationOrPlayedTicket.requestedTotalOdd;

            ticketDialogModel.ticketData = this.createTicketDataFromTicket(ticketDialogModel.confirmationOrPlayedTicket);

            // const taxCalcResult = this.calculateTaxOnWinning(ticketDialogModel.ticketData.possibleWin, ticketDialogModel.ticketData.totalStake);
            // ticketDialogModel.ticketData.taxOnWinings = taxCalcResult.taxOnWinning;
            // ticketDialogModel.ticketData.possibleWinWithoutTax = taxCalcResult.possibleWinWithoutTax;

            // if (ticketDialogModel.ticketData.minWinings) {
            //   const minTaxCalculationResult = this.calculateTaxOnWinning(ticketDialogModel.ticketData.minWinings, ticketDialogModel.ticketData.totalStake);
            //   ticketDialogModel.ticketData.possibleMinPayout = minTaxCalculationResult.possibleWinWithoutTax;
            //   ticketDialogModel.ticketData.taxOnMinWinning = minTaxCalculationResult.taxOnWinning;
            // }


            Object.keys(ticketDialogModel.ticketItemEventGroups).forEach(key => {
              const ev: ITicketItemGroup = ticketDialogModel.ticketItemEventGroups[key];
              const updatedTicketItem: IUpdatedTicketItem = {} as IUpdatedTicketItem;
              const itemsOnEvent: ITicketOutcomeIdentifyer[] = Object.entries(ev.ticketItems).map(([k, ti]) => ({ outcomeId: ti.betOutcomeId, outcomeTypeId: ti.betTypeOutcomeId }));

              const oddForEvent: IOddContainer = this.getMInAndMaxOddForEvent(ev.eventId, itemsOnEvent, this.ticketItemGroupsInTicket);
              updatedTicketItem.updatedOdd = oddForEvent.maxOdd;
              updatedTicketItem.minOdd = oddForEvent.minOdd;
              updatedTicketItem.betOutcomeId = ev.eventId;
              // this.updateTicket.emit({ event: updatedTicketItem, newStake: confirmationTicket.totalStake }); // llater skontaj ovo
            });

            ticketDialogModel.ticketItemsLength = Object.keys(ticketDialogModel.ticketItemEventGroups).length;
            this.dialogModel = null;
            this.notificationService.closeNotification();
            // call confirm dialog and send data
            this.notificationService.forwardDataToTicketDialog(ticketDialogModel);
          }
          else {
            this.notificationService.closeNotification();
            const isTicketChangedWebCheck = true; // input
            this.showConfirmAndRecalculate(tc);
          }

        } else if (tc.validatedTicket.ticketValidationState.ticketStatus === TicketStatus.FastTicket) {
          notification.errorType = ErrorType.CloseDialog;
          if (ViewConfigurations.removeTicektItemsAfterTicketIsPlayed) {
            this.removeAllTicketItems();
          }
          notification.title = DynamicTranslations.ticketValidation_title;
          notification.message = DynamicTranslations.ticketValidation_fastTicketCreated_ErrorMessage + '\n' + DynamicTranslations.ticketValidation_ticketId + tc.validatedTicket.fastTicketCode;
          this.ticketPlayedSuccessfully(null, tc.validatedTicket.fastTicketCode);
          this.googleAnalyticsService.eventEmitter('Uplata listića', 'Express listić', tc.validatedTicket.fastTicketCode);
          this.dialogModel = null;
          this.notificationService.forwardDataToNotification(notification);
        } else if (tc.validatedTicket.ticketValidationState.ticketStatus === TicketStatus.WaitingApproval) {
          notification.errorType = ErrorType.Authorization;
          notification.title = DynamicTranslations.ticketValidation_title;
          notification.message = DynamicTranslations.ticketValidation_ticketValidation_Autorization;
          this.notificationService.forwardDataToNotification(notification);

          const confirmRequest: ITicketConfirmationRequestTO = {
            ticketValidationId: tc.validatedTicket.ticketValidationId,
            officeId: this.ticketManagerUserService.officeId,
            source: RequestSource.Web,
            webPlatformCurrency: this.userService.user.userCurrency,
            webPlatformLanguage: this.userService.user.userLanguage,
            webPlatformUsername: this.userService.user.userName
          };

          this.checkTicket(confirmRequest).subscribe(ti => {
            if (ti) {
              this.processTicketValidationRespose(ti, false, false);
            } else {
              this.checkTicketPing(false);
            }
          });

        }
      }

    } else {
      notification.title = DynamicTranslations.ticketValidation_title;
      notification.message = DynamicTranslations.ticketValidation_otherValidationProblem_ErrorMessage;
      this.notificationService.forwardDataToNotification(notification);
    }
  }

  checkTicketPing(openDialogWithTimer: boolean) {
    if (!this.storage.ticketValidationId) {
      return;
    }

    if (!this.dialogModel) {
      this.dialogModel = this.storage.dialogModel;
    }

    const confirmRequest: ITicketConfirmationRequestTO = {
      ticketValidationId: this.storage.ticketValidationId,
      officeId: environment.betWebOfficeId,
      source: RequestSource.Web,
      webPlatformCurrency: this.userService.user.userCurrency,
      webPlatformLanguage: this.userService.user.userLanguage,
      webPlatformUsername: this.userService.user.userName
    };

    this.ticketProviderService.getStatusOfAuthorizationTicket(confirmRequest).subscribe(async r => {
      if (r) {
        const betTypeShowTypes = await this.settingsService.getBetTypeShowTypes().toPromise();
        const ticketValidationResult = this.modelMapper.mapTicketValidationResult(r, this.ticketManagerUserService.officeId, betTypeShowTypes);

        if (ticketValidationResult.validatedTicket?.ticketValidationState?.ticketStatus === TicketStatus.Approved) {
          if (openDialogWithTimer) {
            this.openAuthorizationDialog();
          }

          setTimeout(() => {
            this.checkTicketPing(false);
          }, 5000);
        } else {
          this.storage.ticketValidationId = null;
          this.storage.dialogModel = null;
          this.processTicketValidationRespose(ticketValidationResult, false, false);
        }
      } else {
        if (openDialogWithTimer) {
          this.openAuthorizationDialog();
        }

        setTimeout(() => {
          this.checkTicketPing(false);
        }, 5000);
      }
    },
      (error) => {
        this.storage.ticketValidationId = null;
        this.storage.dialogModel = null;
        const notification: ICustomNotification = {
          errorLevel: ErrorLevel.Notification,
          errorType: ErrorType.CloseDialog,
          title: DynamicTranslations.communication_Error_title,
          message: DynamicTranslations.notification_TicketPing_Error,
        } as ICustomNotification;

        this.notificationService.forwardDataToNotification(notification);
        return of(null);
      });
  }

  private openAuthorizationDialog() {
    const notification: ICustomNotification = {
      errorLevel: ErrorLevel.Notification,
      errorType: ErrorType.Authorization,
      title: DynamicTranslations.ticketValidation_title,
      message: DynamicTranslations.ticketValidation_ticketValidation_Autorization,
    } as ICustomNotification;
    this.notificationService.forwardDataToNotification(notification);
  }

  saveSentOdds(ticket: ITicketTO): void {
    ticket.groups.forEach(gr => {
      // eslint-disable-next-line guard-for-in
      // tslint:disable-next-line:forin
      for (const key in gr.ticketItems) {
        if (gr.ticketItems.hasOwnProperty(key)) {
          const value = gr.ticketItems[key];
          this.sentOdds[value.betOutcomeId] = value.acceptedOdd;
        }
      }
    });
  }

  createTicketDataFromTicket(ticket: ITicket): ITicketData {
    const ticketData = {} as ITicketData;

    ticketData.isTicketOnline = true;
    ticketData.numberOfBets = ticket.numOfCombinations;
    ticketData.totalStake = ticket.totalStake;
    ticketData.wagerPerBet = ticket.totalStake / ticket.numOfCombinations;
    ticketData.totalWinings = ticket.possibleWin;
    ticketData.minWinings = ticket.minWinings;
    ticketData.totalOdd = ticket.totalOdd;
    ticketData.minOdd = ticket.minOdd;
    ticketData.possibleWin = ticket.possibleWin;
    ticketData.bonus = ticket.bonus;
    ticketData.bonusPercent = ticket.bonusPercent;
    ticketData.freeBetValue = ticket.freeBetValue;
    ticketData.freeBetValueToShow = ticket.freeBetValue;
    ticketData.payin = ticket.payin;
    ticketData.taxBeforeStake = ticket.taxBeforeStake;
    ticketData.payin = ticket.payin;
    ticketData.possibleWinWithoutTax = ticket.possibleWinWithoutTax;
    ticketData.possiblePayout = ticket.possiblePayout;
    ticketData.possibleMinPayout = ticket.possibleMinPayout;
    ticketData.taxOnMinWinning = ticket.taxOnMinWinning;
    ticketData.taxOnWinings = ticket.taxOnWinning;

    return ticketData;
  }


  // update ticketItemGroups and call recalculate on ticket base
  // move create ticket functions here so they can be called from
  // call create for selected ticket type -- combi/system fix
  // update oldOdd with sentOdds on newly created ticket
  // send ticket to expand and say odds have been changed
  // also when odds can not be updated(confirm ticket), than create object copies from ticket items or show them in ticket detail template

  showConfirmAndRecalculate(response: ITicketValidationResult) {
    this.dialogModel.ticketType = TicketPlayType.ChangedTicket;
    const oddsMap: { [eventId: number]: number } = {};
    const minOddsMap: { [eventId: number]: number } = {};
    Object.entries(this.dialogModel.ticketItemEventGroups).forEach(([k, gr]) => {
      const ticketItems: ITicketItem[] = Object.entries(gr.ticketItems).map(([k, v]) => v);
      ticketItems.forEach(ti => {
        ti.oldOdd = this.sentOdds[ti.betOutcomeId];

        const index = response.validatedTicket.ticketValidationState.updatedTicketItems.findIndex(up => up.betOutcomeId === ti.betOutcomeId);

        if (index !== -1) {
          const updatedTicketItem = response.validatedTicket.ticketValidationState.updatedTicketItems[index];
          if (ti.odd !== updatedTicketItem.updatedOdd) {
            ti.oldOdd = ti.odd;
            ti.odd = updatedTicketItem.updatedOdd;
          }
        }

      });

      const itemsOnEvent: ITicketOutcomeIdentifyer[] = ticketItems.map(ti => ({ outcomeId: ti.betOutcomeId, outcomeTypeId: ti.betTypeOutcomeId }));
      const oddForEvent: IOddContainer = this.getMInAndMaxOddForEvent(gr.eventId, itemsOnEvent, this.dialogModel.ticketItemEventGroups);
      oddsMap[gr.eventId] = oddForEvent.maxOdd;
      minOddsMap[gr.eventId] = oddForEvent.minOdd;
    });

    // dont do this, just send data to dialog and say it needs to do recalculation(it can do on init when type is set to changed)
    this.notificationService.forwardDataToTicketDialog(this.dialogModel);
  }

  public createTicketFix(
    freeBetValue: number,
    playerFreeBetSettings: IFreeBetSetting,
    orderingForTicketItemGroups: ITicketOrderingItem[],
    ticketItemGroups: { [eventId: number]: ITicketItemGroup },
    ticketData: ITicketData
  ): ITicket {
    const ticketGroup: ITicketGroup = {
      hasMultipleOutcomes: ticketData.numberOfBets > 1,
      id: ConstantValues.BANKERSGROUP_ID,
      typeId: TicketType.Fix,
      k: orderingForTicketItemGroups.length.toString(),
      n: orderingForTicketItemGroups.length,
      ticketItems: {},
      groupType: TicketType.Fix
    };
    let isLive: boolean;

    Object.entries(ticketItemGroups).forEach(([k, gr]) => {
      Object.entries(gr.ticketItems).forEach(([k, ti]) => {
        ticketGroup.ticketItems[ti.betOutcomeId] = this.modelMapper.createTicketItemForTicket(gr, ti);
        if (ti.isLive) {
          isLive = true;
        }
      });
    });

    let freeBetProcessingType: FreeBetProcessingType;
    if (playerFreeBetSettings && freeBetValue !== 0) {
      freeBetProcessingType = playerFreeBetSettings.procesingType;
    } else {
      freeBetProcessingType = null;
    }

    return this.modelMapper.createTicket(
      TicketType.Fix,
      ticketData.numberOfBets,
      [ticketGroup],
      ticketData.totalWinings,
      ticketData.possibleWin,
      ticketData.totalStake,
      ticketData.totalOdd,
      isLive,
      ticketData.bonus,
      ticketData.bonusPercent,
      ticketData.minOdd,
      ticketData.minWinings,
      freeBetValue,
      DynamicTranslations['enumTranslations_' + TicketType[TicketType.Fix]],
      ticketData.taxBeforeStake,
      ticketData.taxOnWinings,
      ticketData.payin,
      freeBetProcessingType,
      ticketData.possibleWinWithoutTax,
      ticketData.possiblePayout,
      ticketData.possibleMinPayout,
      ticketData.taxOnMinWinning);
  }

  public createSystemTicket(
    bankerTicketItemGroups: ITicketItemGroup[],
    systemTicketItemGroups: ITicketItemGroup[],
    isMultiplayBanker: boolean,
    isMultiplaySystem: boolean,
    systemOptions: ISystemOption[],
    freeBetValue: number,
    playerFreeBetSettings: IFreeBetSetting,
    ticketData: ITicketData,
    placeBetType?: TypeOfPlaceBetTicket): ITicket {
    let typeId: TicketType;
    let isLive: boolean;
    const groups: ITicketGroup[] = [];
    if (bankerTicketItemGroups.length > 0) {
      const bankerGroup: ITicketGroup = {
        hasMultipleOutcomes: isMultiplayBanker,
        id: ConstantValues.BANKERSGROUP_ID,
        k: bankerTicketItemGroups.length.toString(),
        n: bankerTicketItemGroups.length,
        typeId: ConstantValues.FIX_TICKET_TYPE_ID,
        groupType: TicketType.Fix,
        ticketItems: {},
      };
      bankerTicketItemGroups.forEach(group => {
        Object.entries(group.ticketItems).forEach(([k, ti]) => {
          bankerGroup.ticketItems[ti.betOutcomeId] = this.modelMapper.createTicketItemForTicket(group, ti);
          bankerGroup.ticketItems[ti.betOutcomeId].isFix = true;
          if (ti.isLive) {
            isLive = true;
          }
        });
      });
      groups.push(bankerGroup);
    }
    if (systemTicketItemGroups.length > 0) {
      const systemGroup: ITicketGroup = {
        hasMultipleOutcomes: isMultiplaySystem,
        id: ConstantValues.SYSTEMSGROUP_ID,
        k: '',
        ticketItems: {},
      } as ITicketGroup;
      let tmpType = 0;

      systemOptions.forEach(syso => {
        if (syso.optionSelected) {
          tmpType++;
          systemGroup.k = systemGroup.k.concat(syso.eventsInCombination.toString() + ';');
        }
      });
      systemGroup.k = systemGroup.k.slice(0, systemGroup.k.length - 1);

      if (tmpType > 1) {
        typeId = TicketType.ExpandedSystem;
      } else {
        const index = systemOptions.findIndex(sy => sy.optionSelected === true);
        if (index > -1) {
          if (systemOptions[index].eventsInCombination === systemTicketItemGroups.length) {
            typeId = TicketType.Fix;
          } else {
            typeId = TicketType.System;
          }
        }
      }

      systemGroup.n = systemTicketItemGroups.length;
      systemGroup.typeId = typeId;
      systemTicketItemGroups.forEach(group => {
        Object.entries(group.ticketItems).forEach(([k, ti]) => {
          systemGroup.ticketItems[ti.betOutcomeId] = this.modelMapper.createTicketItemForTicket(group, ti);
          if (ti.isLive) {
            isLive = true;
          }
        });
      });

      groups.push(systemGroup);
    }

    let freeBetProcessingType: FreeBetProcessingType;
    if (playerFreeBetSettings && freeBetValue !== 0) {
      freeBetProcessingType = playerFreeBetSettings.procesingType;
    } else {
      freeBetProcessingType = null;
    }

    return this.modelMapper.createTicket(
      typeId,
      ticketData.numberOfBets,
      groups,
      ticketData.totalWinings,
      ticketData.possibleWin,
      ticketData.totalStake,
      ticketData.totalOdd,
      isLive,
      ticketData.bonus,
      ticketData.bonusPercent,
      ticketData.minOdd,
      ticketData.minWinings,
      freeBetValue,
      DynamicTranslations['enumTranslations_' + TicketType[typeId]],
      ticketData.taxBeforeStake,
      ticketData.taxOnWinings,
      ticketData.payin,
      freeBetProcessingType,
      ticketData.possibleWinWithoutTax,
      ticketData.possiblePayout,
      ticketData.possibleMinPayout,
      ticketData.taxOnMinWinning,
    );
  }

  private isFreeBetPossible(fbSetting: IFreeBetSetting, totalStake: number, numberOfBets: number, orderingForTicketItemGroups: ITicketOrderingItem[], totalOdd: number): boolean {

    const dateTimeNow: Date = new Date();
    // const nowUtc = new Date(
    //   dateTimeNow.getUTCFullYear(),
    //   dateTimeNow.getUTCMonth(),
    //   dateTimeNow.getUTCDate(),
    //   dateTimeNow.getUTCHours(),
    //   dateTimeNow.getUTCMinutes(),
    //   dateTimeNow.getUTCSeconds());


    if (fbSetting == null) {
      return false;
    }

    if (dateTimeNow < fbSetting.fromDate) {
      return false;
    }

    if (dateTimeNow > fbSetting.toDate) {
      return false;
    }


    if (Object.keys(this.ticketItemGroups).length < fbSetting.minTicketItems) {
      return false;
    }

    if (fbSetting.fromStake) {
      if (totalStake < fbSetting.fromStake) {
        return false;
      }
    }

    if (fbSetting.toStake) {
      if (totalStake > fbSetting.toStake) {
        return false;
      }
    }

    if (totalOdd < fbSetting.minimumGlobalOdd) {
      return false;
    }

    // ONLY FIXED TICKET WITH NO MULTIWAY CAN HAVE FB
    if (numberOfBets > 1) {
      return false;
    }

    const ticketItems: { eventId: number; btoId: number }[] = [];
    orderingForTicketItemGroups.forEach((oItem) => {
      oItem.outcomeIds.forEach((oid) => ticketItems.push({ eventId: oItem.eventId, btoId: oid }));
    });

    const arrOdds = ticketItems.map(x => this.ticketItemGroups[x.eventId].ticketItems[x.btoId].odd);

    // const minEventOdd = Math.min(...arrOdds);

    // if (minEventOdd < fbSetting.minimumEventOdd) {
    //   return false;
    // }
    let filteredMinEvOddTicketItems: { eventId: number; btoId: number }[] = [];
    // new workflow
    if (fbSetting.minimumEventOdd && fbSetting.minTicketItems && fbSetting.minTicketItems > 0) {
      filteredMinEvOddTicketItems = ticketItems.filter(ti => this.ticketItemGroups[ti.eventId].ticketItems[ti.btoId].odd >= fbSetting.minimumEventOdd);
      if (filteredMinEvOddTicketItems.length < fbSetting.minTicketItems) {
        return false;
      }

      filteredMinEvOddTicketItems.sort((ti1, ti2) => this.ticketItemGroups[ti1.eventId].ticketItems[ti1.btoId].odd - this.ticketItemGroups[ti2.eventId].ticketItems[ti2.btoId].odd);
      filteredMinEvOddTicketItems = filteredMinEvOddTicketItems.slice(0, fbSetting.minTicketItems);
    }

    if (fbSetting.minimumRestItemsOdd) {
      const filteredRestOddTicketItems = ticketItems.filter(ti => filteredMinEvOddTicketItems.findIndex(fti => fti.btoId === ti.btoId) < 0);

      if (filteredRestOddTicketItems.findIndex(ti => this.ticketItemGroups[ti.eventId].ticketItems[ti.btoId].odd < fbSetting.minimumRestItemsOdd) > -1) {
        return false;
      }
    }



    let eventType: EventTypeBonusSetting;

    if (ticketItems.every(x => !this.ticketItemGroups[x.eventId].ticketItems[x.btoId].isLive)) {
      eventType = EventTypeBonusSetting.Prematch;
    }
    else if (ticketItems.every(x => this.ticketItemGroups[x.eventId].ticketItems[x.btoId].isLive)) {
      eventType = EventTypeBonusSetting.Live;
    }
    else {
      eventType = EventTypeBonusSetting.Both;
    }


    if (fbSetting.eventType !== EventTypeBonusSetting.Both) {
      if (fbSetting.eventType !== eventType) {
        return false;
      }
    }

    // DONT USE SETTINGS ONLY FIXED TICKET WITH NO MULTIWAY CAN HAVE FB
    // if (fbSetting.betslipType !== BetslipTypeFreeBetSetting.Both) {
    //   let betslipType: BetslipTypeFreeBetSetting;

    //   if (numberOfBets > 1) {
    //     betslipType = BetslipTypeFreeBetSetting.System;
    //   }
    //   else {
    //     betslipType = BetslipTypeFreeBetSetting.Fix;
    //   }

    //   if (fbSetting.betslipType !== betslipType) {
    //     return false;
    //   }
    // }


    if (!fbSetting.isAllEventsSeleted) {

      const eventIDs: Array<number> = new Array<number>();
      fbSetting.hierarchies.forEach(hierarchySetting => {

        orderingForTicketItemGroups.forEach(order => {
          if (hierarchySetting.eventId) {
            if (order.eventId === hierarchySetting.eventId && !eventIDs.some(x => x === order.eventId)) {
              eventIDs.push(order.eventId);
            }
          } else if (hierarchySetting.competitionId) {
            if (this.ticketItemGroups[order.eventId].competitionId === hierarchySetting.competitionId && !eventIDs.some(x => x === order.eventId)) {
              eventIDs.push(order.eventId);
            }
          }
          else if (hierarchySetting.regionId) {
            if (this.ticketItemGroups[order.eventId].regionId === hierarchySetting.regionId && !eventIDs.some(x => x === order.eventId)) {
              eventIDs.push(order.eventId);
            }
          }
          else if (this.ticketItemGroups[order.eventId].sportId === hierarchySetting.sportId && !eventIDs.some(x => x === order.eventId)) {
            eventIDs.push(order.eventId);
          }

        });

      });

      if (eventIDs.length === 0) {
        return false;
      }

      if (fbSetting.sportTreeCondition === SportTreeCondition.OnlySelected && (eventIDs.length !== ticketItems.length)) {
        return false;
      }
    }

    return true;

  }


  public calculateFreeBet(
    playerFreeBetSettings: IFreeBetSetting,
    freeBetBalance: number,
    numberOfBets: number,
    orderingForTicketItemGroups: ITicketOrderingItem[],
    wagerPerBet: number,
    totalOdd: number,
    totalWinings: number,
    bonus: number,
    totalStake: number): { freeBetValue: number; freeBetValueToShow: number } {
    const retVal: { freeBetValue: number; freeBetValueToShow: number } = { freeBetValue: 0, freeBetValueToShow: 0 };



    // if (!environment.localDeploy) {
    //   if (freeBetBalance <= 0) {
    //     return retVal;
    //   }
    // }


    if (this.isFreeBetPossible(playerFreeBetSettings, totalStake, numberOfBets, orderingForTicketItemGroups, totalOdd)) {
      switch (playerFreeBetSettings.procesingType) {
        case FreeBetProcessingType.WonAmountWithoutStake:
          retVal.freeBetValue = totalOdd * wagerPerBet - totalStake;
          break;
        case FreeBetProcessingType.WonAmountWithoutStakeAndStakeInWallet:
          retVal.freeBetValue = totalOdd * wagerPerBet - totalStake;
          break;
        case FreeBetProcessingType.StakeOnly:
          retVal.freeBetValue = totalStake;
          break;
        case FreeBetProcessingType.WonAmount:
          retVal.freeBetValue = totalWinings;
          break;
        default:
          break;
      }

      if (playerFreeBetSettings.includeBonus) {
        retVal.freeBetValueToShow = retVal.freeBetValue + bonus;
      }
      else {
        retVal.freeBetValueToShow = retVal.freeBetValue;
      }

      retVal.freeBetValueToShow = this.utilityService.roundByBusinessModel(retVal.freeBetValueToShow);

      const maxWinnings = this.getMaxWinningsByBussinesModel(totalStake);
      if (retVal.freeBetValueToShow > maxWinnings) {
        retVal.freeBetValueToShow = maxWinnings;
      }
    }
    return retVal;
  }


  public calculateBonus(
    playerBonussSettings: IBonusSettings[],
    bonussSettings: IBonusSettings[],
    totalStake: number,
    totalOdd: number,
    numberOfBets: number,
    totalWinings: number,
    orderingForTicketItemGroups: ITicketOrderingItem[],
    wagerPerBet: number): { bonusPercent: number; bonus: number; possibleWin: number } {
    let bonusPercentValue = 0;
    const retVal: { bonusPercent: number; bonus: number; possibleWin: number } = { bonusPercent: 0, bonus: 0, possibleWin: 0 };

    let bonusSettings: Array<IBonusSettings> = new Array<IBonusSettings>();

    if ((this.userService.user?.userName || this.storage.affiliate?.affiliateId) && playerBonussSettings.length > 0) {
      bonusSettings = playerBonussSettings;
    }
    else {
      bonusSettings = bonussSettings;
    }

    bonusSettings.forEach(bonus => {

      if (this.isBonusConditionFullfiled(bonus, orderingForTicketItemGroups, wagerPerBet, totalOdd)) {
        bonusPercentValue += bonus.bonus;

      }

    });

    retVal.bonusPercent = bonusPercentValue;
    retVal.bonus = retVal.bonus + (bonusPercentValue / 100) * totalOdd * totalStake / numberOfBets;
    retVal.possibleWin = totalWinings + retVal.bonus;
    const maxWinnings = this.getMaxWinningsByBussinesModel(totalStake);
    if (retVal.possibleWin > maxWinnings) {
      retVal.possibleWin = maxWinnings;
    }

    return retVal;
  }

  private isBonusConditionFullfiled(bonusSettings: IBonusSettings, orderingForTicketItemGroups: ITicketOrderingItem[], wagerPerBet: number, totalOdd: number): boolean {

    // for date

    // bonusSettings.fromDateD = new Date(bonusSettings.fromDate);
    // bonusSettings.toDateD = new Date(bonusSettings.toDate);



    const dateTimeNow: Date = new Date();

    const nowUtc = new Date(
      dateTimeNow.getUTCFullYear(),
      dateTimeNow.getUTCMonth(),
      dateTimeNow.getUTCDate(),
      dateTimeNow.getUTCHours(),
      dateTimeNow.getUTCMinutes(),
      dateTimeNow.getUTCSeconds());

    if (nowUtc < bonusSettings.fromDate || (bonusSettings.toDate && nowUtc > bonusSettings.toDate)) {
      return false;
    }

    if (bonusSettings.isHappyHour) {

      const happyHourFromList: string[] = bonusSettings.happyHourFrom.split(':');
      const happyHourToList: string[] = bonusSettings.happyHourTo.split(':');

      const fromHour: number = +happyHourFromList[0];
      const fromMinutes: number = +happyHourFromList[1];
      const fromSecounds: number = +happyHourFromList[2];

      const toHour: number = +happyHourToList[0];
      const toMinutes: number = +happyHourToList[1];
      const toSecounds: number = +happyHourToList[2];

      const happyHourFrom: Date = new Date(dateTimeNow.getFullYear(), dateTimeNow.getMonth(), dateTimeNow.getDate(), fromHour, fromMinutes, fromSecounds);

      const happyHourTo: Date = new Date(dateTimeNow.getFullYear(), dateTimeNow.getMonth(), dateTimeNow.getDate(), toHour, toMinutes, toSecounds);

      if (dateTimeNow.getTime() < happyHourFrom.getTime() || dateTimeNow.getTime() > happyHourTo.getTime()) {
        return false;
      }
    }

    if (bonusSettings.fromStake) {
      if (wagerPerBet < bonusSettings.fromStake) {
        return false;
      }
    }

    if (bonusSettings.toStake) {
      if (wagerPerBet > bonusSettings.toStake && bonusSettings.toStake > 0) {
        return false;
      }
    }

    const ticketItems: { eventId: number; btoId: number }[] = [];
    orderingForTicketItemGroups.forEach((oItem) => {
      oItem.outcomeIds.forEach((oid) => ticketItems.push({ eventId: oItem.eventId, btoId: oid }));
    });


    if (bonusSettings.minimumEventOddMode === MinimumEventOddMode.ApplyToWholeTicket) {
      if (ticketItems.some(x => this.ticketItemGroups[x.eventId].ticketItems[x.btoId].odd < bonusSettings.minimumEventOdd)) {
        return false;
      }
    }

    let tempTicketItems: { eventId: number; btoId: number }[] = [];

    switch (bonusSettings.eventType) {
      case EventTypeBonusSetting.Both:
        tempTicketItems = ticketItems;
        break;
      case EventTypeBonusSetting.Prematch:
        tempTicketItems = ticketItems.filter(x => !this.ticketItemGroups[x.eventId].ticketItems[x.btoId].isLive);
        break;
      case EventTypeBonusSetting.Live:
        tempTicketItems = ticketItems.filter(x => this.ticketItemGroups[x.eventId].ticketItems[x.btoId].isLive);
        break;
    }

    let countItems = 0;
    if (tempTicketItems.length > 0) {
      if (bonusSettings.minimumEventOddMode === MinimumEventOddMode.ApplyToWholeTicket) {
        countItems = tempTicketItems.length;
      }
      else {
        const tempList = tempTicketItems.filter(x => this.ticketItemGroups[x.eventId].ticketItems[x.btoId].odd >= bonusSettings.minimumEventOdd);
        if (tempList.length > 0) {
          countItems = tempList.length;
        }
      }
    }

    if (countItems < bonusSettings.fromSelections || (countItems > bonusSettings.toSelections && bonusSettings.toSelections > 0)) {
      return false;
    }

    if (bonusSettings.minimumGlobalOdd !== null && totalOdd < bonusSettings.minimumGlobalOdd) {
      return false;
    }

    if (!bonusSettings.isAllEventSelected) {

      const eventIDs: Array<number> = new Array<number>();
      bonusSettings.hierarchies.forEach(hierarchySetting => {

        orderingForTicketItemGroups.forEach(order => {

          if (hierarchySetting.competitionId) {
            if (this.ticketItemGroups[order.eventId].competitionId === hierarchySetting.competitionId && !eventIDs.some(x => x === order.eventId)) {
              eventIDs.push(order.eventId);
            }
          }
          else if (hierarchySetting.regionId) {
            if (this.ticketItemGroups[order.eventId].regionId === hierarchySetting.regionId && !eventIDs.some(x => x === order.eventId)) {
              eventIDs.push(order.eventId);
            }
          }
          else if (this.ticketItemGroups[order.eventId].sportId === hierarchySetting.sportId && !eventIDs.some(x => x === order.eventId)) {
            eventIDs.push(order.eventId);
          }
        });

      });

      if (eventIDs.length === 0) {
        return false;
      }

      if (bonusSettings.sportCondition === SportTreeCondition.OnlySelected && (eventIDs.length !== ticketItems.length)) {
        return false;
      }
    }

    return true;

  }

  public calculateRegularSystemOdds(
    sysOpt: ISystemOption,
    systemTicketItemGroups: ITicketItemGroup[],
    orderingForTicketItemGroups: ITicketOrderingItem[],
    oddsMap: { [eventId: number]: number },
    minOddsMap: { [eventId: number]: number },
    calculateOddsForNumberOfHits: boolean,
    maxOddsSysEvIdsByOddHiToLowWithoutBankers: { [eventId: number]: number },
    minOddsSysEvIdsByOddLowToHiWithoutBankers: { [eventId: number]: number }) {

    let selectedSystemOdds = 0;
    let selectedSystemMinOdds: number = Number.MAX_VALUE;
    let cmb: any = {};
    sysOpt.oddsForNumberOfHits = {};

    if (systemTicketItemGroups.length > 30) {
      //  cmb = Combinatorics.bigCombination<number>(this.events.map(ev => ev.eventId), sysOpt.eventsInCombination);
    } else {
      cmb = Combinatorics.combination<number>(orderingForTicketItemGroups.map(o => o.eventId), sysOpt.eventsInCombination);
    }
    for (let i = 0; i < Math.round(cmb.length); i++) {
      const combo = cmb.next();
      let maxComboOdd = 1;
      let minComboOdd = 1;
      let minInd = -1;
      let maxInd = -1;
      combo.forEach((evnt: number) => {
        maxComboOdd *= oddsMap[evnt];
        minComboOdd *= minOddsMap[evnt];
        if (calculateOddsForNumberOfHits) {
          if (maxInd < maxOddsSysEvIdsByOddHiToLowWithoutBankers[evnt]) {
            maxInd = maxOddsSysEvIdsByOddHiToLowWithoutBankers[evnt];
          }

          if (minInd < minOddsSysEvIdsByOddLowToHiWithoutBankers[evnt]) {
            minInd = minOddsSysEvIdsByOddLowToHiWithoutBankers[evnt];
          }
        }
      });
      selectedSystemOdds += maxComboOdd;
      if (minComboOdd < selectedSystemMinOdds) {
        selectedSystemMinOdds = minComboOdd;
      }
      if (calculateOddsForNumberOfHits) {
        for (let index = systemTicketItemGroups.length; index >= maxInd; index--) {
          if (!sysOpt.oddsForNumberOfHits[index]) {
            sysOpt.oddsForNumberOfHits[index] = { maxOdds: 0, minOdds: 0 };
          }
          sysOpt.oddsForNumberOfHits[index].maxOdds += maxComboOdd;
        }

        for (let index = systemTicketItemGroups.length; index >= minInd; index--) {
          if (!sysOpt.oddsForNumberOfHits[index]) {
            sysOpt.oddsForNumberOfHits[index] = { maxOdds: 0, minOdds: 0 };
          }
          sysOpt.oddsForNumberOfHits[index].minOdds += minComboOdd;
        }
      }
    }

    sysOpt.maxOdds = selectedSystemOdds;
    sysOpt.minOdds = selectedSystemMinOdds;





  }

  public calculateBankerSystemOdds(
    sysOpt: ISystemOption,
    systemTicketItemGroups: ITicketItemGroup[],
    bankerTicketItemGroups: ITicketItemGroup[],
    oddsMap: { [eventId: number]: number },
    minOddsMap: { [eventId: number]: number },
    calculateOddsForNumberOfHits: boolean,
    maxOddsSysEvIdsByOddHiToLowWithoutBankers: { [eventId: number]: number },
    minOddsSysEvIdsByOddLowToHiWithoutBankers: { [eventId: number]: number }) {
    let selectedSystemOdds = 0;
    let selectedSystemMinOdds: number = Number.MAX_VALUE;
    sysOpt.oddsForNumberOfHits = {};
    const bankerOdd = this.calculateBankerOdds(bankerTicketItemGroups, oddsMap, minOddsMap);
    let cmb: any = {};

    if (systemTicketItemGroups.length > 30) {
      // cmb = Combinatorics.bigCombination<number>(systemTicketItemGroups.map(ev => ev.eventId), sysOpt.eventsInCombination);

    } else {
      cmb = Combinatorics.combination<number>(systemTicketItemGroups.map(g => g.eventId), sysOpt.eventsInCombination);
    }
    for (let i = 0; i < Math.round(cmb.length); i++) {
      const combo = cmb.next();
      let maxComboOdd = 1;
      let minComboOdd = 1;
      let minInd = -1;
      let maxInd = -1;
      combo.forEach((evnt: number) => {
        maxComboOdd *= oddsMap[evnt];
        minComboOdd *= minOddsMap[evnt];
        if (calculateOddsForNumberOfHits) {
          if (maxInd < maxOddsSysEvIdsByOddHiToLowWithoutBankers[evnt]) {
            maxInd = maxOddsSysEvIdsByOddHiToLowWithoutBankers[evnt];
          }

          if (minInd < minOddsSysEvIdsByOddLowToHiWithoutBankers[evnt]) {
            minInd = minOddsSysEvIdsByOddLowToHiWithoutBankers[evnt];
          }
        }
      });
      selectedSystemOdds += maxComboOdd;
      if (minComboOdd < selectedSystemMinOdds) {
        selectedSystemMinOdds = minComboOdd;
      }
      if (calculateOddsForNumberOfHits) {
        const eventsLength = systemTicketItemGroups.length + bankerTicketItemGroups.length;

        for (let index = eventsLength; index >= maxInd; index--) {
          if (!sysOpt.oddsForNumberOfHits[index]) {
            sysOpt.oddsForNumberOfHits[index] = { maxOdds: 0, minOdds: 0 };
          }
          sysOpt.oddsForNumberOfHits[index].maxOdds += maxComboOdd;
        }

        for (let index = eventsLength; index >= minInd; index--) {
          if (!sysOpt.oddsForNumberOfHits[index]) {
            sysOpt.oddsForNumberOfHits[index] = { maxOdds: 0, minOdds: 0 };
          }
          sysOpt.oddsForNumberOfHits[index].minOdds += minComboOdd;
        }

      }
    }
    if (calculateOddsForNumberOfHits) {
      for (const numOfHits of Object.keys(sysOpt.oddsForNumberOfHits)) {
        sysOpt.oddsForNumberOfHits[+numOfHits].maxOdds *= bankerOdd.maxOdd;
        sysOpt.oddsForNumberOfHits[+numOfHits].minOdds *= bankerOdd.minOdd;
      }
    }

    sysOpt.maxOdds = selectedSystemOdds * bankerOdd.maxOdd;
    sysOpt.minOdds = selectedSystemMinOdds * bankerOdd.minOdd;
  }

  public calculateBankerOdds(bankerTicketItemGroups: ITicketItemGroup[], oddsMap: { [eventId: number]: number }, minOddsMap: { [eventId: number]: number }): IOddContainer {
    let maxBankerOdd = 1;
    let minBanlerOdd = 1;
    bankerTicketItemGroups.forEach(ev => {

      maxBankerOdd *= oddsMap[ev.eventId];
      minBanlerOdd *= minOddsMap[ev.eventId];

    });

    const odd: IOddContainer = {
      maxOdd: maxBankerOdd,
      minOdd: minBanlerOdd,
    };
    return odd;
  }

  updateOddsSystemOptions(
    systemOptions: ISystemOption[],
    orderingForTicketItemGroups: ITicketOrderingItem[],
    systemTicketItemGroups: ITicketItemGroup[],
    bankerTicketItemGroups: ITicketItemGroup[],
    oddsMap: { [eventId: number]: number },
    minOddsMap: { [eventId: number]: number },
    isTicketLive: boolean,
    maxOddsSysEvIdsByOddHiToLowWithoutBankers: { [eventId: number]: number },
    minOddsSysEvIdsByOddLowToHiWithoutBankers: { [eventId: number]: number }) {


    for (const sysOpt of systemOptions) {
      if (Object.keys(bankerTicketItemGroups).length > 0) {

        this.calculateBankerSystemOdds(
          sysOpt,
          systemTicketItemGroups,
          bankerTicketItemGroups,
          oddsMap,
          minOddsMap,
          !isTicketLive && ViewConfigurations.showNumberOfHitsForTicketSystem,
          maxOddsSysEvIdsByOddHiToLowWithoutBankers,
          minOddsSysEvIdsByOddLowToHiWithoutBankers);
      } else {
        this.calculateRegularSystemOdds(
          sysOpt,
          systemTicketItemGroups,
          orderingForTicketItemGroups,
          oddsMap,
          minOddsMap,
          !isTicketLive && ViewConfigurations.showNumberOfHitsForTicketSystem,
          maxOddsSysEvIdsByOddHiToLowWithoutBankers,
          minOddsSysEvIdsByOddLowToHiWithoutBankers);
      }
    }
  }

  public calculateOddAndWiningsTicketFix(
    oddsMap: { [eventId: number]: number },
    minOddsMap: { [eventId: number]: number },
    totalStake,
    wagerPerBet,
    numberOfBets,
    playerFreeBetSettings: IFreeBetSetting,
    freeBetBalance: number,
    playerBonussSettings: IBonusSettings[],
    bonussSettings: IBonusSettings[],
    orderingForTicketItemGroups: ITicketOrderingItem[],
    payin,
    taxBeforeStake): ITicketData {
    const ticketData: ITicketData = {
      wagerPerBet,
      totalOdd: 0,
      totalWinings: 0,
      bonus: 0,
      totalStake,
      numberOfBets,
      minWinings: 0,
      minOdd: 0,
      possibleWin: 0,
      bonusPercent: 0,
      freeBetValue: 0,
      freeBetValueToShow: 0,
      payin,
      taxBeforeStake,
      taxOnWinings: 0,
      possibleWinWithoutTax: 0,
      possiblePayout: 0,
      possibleMinPayout: 0,
      taxOnMinWinning: 0,
    } as ITicketData;
    let maxOdds = 1;
    let minOdds = 1;
    for (const eventId in oddsMap) {
      if (oddsMap[eventId]) {
        maxOdds *= oddsMap[eventId];
        minOdds *= minOddsMap[eventId];
      }
    }
    ticketData.totalOdd = maxOdds;
    ticketData.minOdd = minOdds;

    if (totalStake > 0 && ticketData.numberOfBets > 0) {
      ticketData.totalWinings = ticketData.totalOdd * wagerPerBet;
      ticketData.minWinings = ticketData.minOdd * wagerPerBet;

      ticketData.totalWinings = this.utilityService.roundByBusinessModel(ticketData.totalWinings);
      ticketData.minWinings = this.utilityService.roundByBusinessModel(ticketData.minWinings);

      const maxWinnings = this.getMaxWinningsByBussinesModel(totalStake);
      if (ticketData.totalWinings > maxWinnings) {
        ticketData.totalWinings = maxWinnings;
      }
      if (ticketData.minWinings > maxWinnings) {
        ticketData.minWinings = maxWinnings;
      }
    }
    else {
      ticketData.totalWinings = 0;
      ticketData.minWinings = 0;
    }
    if (ticketData.numberOfBets > 1) {
      ticketData.possibleWin = ticketData.totalWinings;
    }

    if (this.ticketData.numberOfBets === 1) {
      const bonusses = this.calculateBonus(playerBonussSettings, bonussSettings, totalStake, ticketData.totalOdd, ticketData.numberOfBets, ticketData.totalWinings, orderingForTicketItemGroups, ticketData.wagerPerBet);
      ticketData.bonus = bonusses.bonus;
      ticketData.bonusPercent = bonusses.bonusPercent;
      ticketData.possibleWin = bonusses.possibleWin;
    } else {
      ticketData.bonus = 0;
      ticketData.bonusPercent = 0;
    }

    const fb = this.calculateFreeBet(playerFreeBetSettings, freeBetBalance, ticketData.numberOfBets, orderingForTicketItemGroups, wagerPerBet, ticketData.totalOdd, ticketData.totalWinings, ticketData.bonus, ticketData.totalStake);
    ticketData.freeBetValue = fb.freeBetValue;
    ticketData.freeBetValueToShow = fb.freeBetValueToShow;


    const taxCalcResult = this.calculateTaxOnWinning(ticketData.possibleWin, totalStake);
    ticketData.taxOnWinings = taxCalcResult.taxOnWinning;
    ticketData.possibleWinWithoutTax = taxCalcResult.possibleWinWithoutTax;


    const minTaxCalculationResult = this.calculateTaxOnWinning(ticketData.minWinings, totalStake);
    ticketData.possibleMinPayout = minTaxCalculationResult.possibleWinWithoutTax;
    ticketData.taxOnMinWinning = minTaxCalculationResult.taxOnWinning;





    return ticketData;
  }

  public calculateOddsAndWinningsForUpdatedSystemOptions(
    systemOptions: ISystemOption[],
    playerFreeBetSettings: IFreeBetSetting,
    playerBonussSettings: IBonusSettings[],
    bonussSettings: IBonusSettings[],
    freeBetBalance: number,
    isFix: boolean,
    orderingForTicketItemGroups: ITicketOrderingItem[],
    wagerPerBet: number,
    totalStake: number,
    numberOfBets: number,
    payin: number,
    taxBeforeStake: number,
    calculateOddsForNumberOfHits: boolean,
    calculateFreeBetAndBonus: boolean = true): ITicketData {
    const ticketData: ITicketData = {
      wagerPerBet,
      totalOdd: 0,
      totalWinings: 0,
      bonus: 0,
      totalStake,
      numberOfBets: 0,
      minWinings: 0,
      minOdd: 1,
      possibleWin: 0,
      bonusPercent: 0,
      freeBetValue: 0,
      freeBetValueToShow: 0,
      payin,
      taxBeforeStake,
      taxOnWinings: 0,
      possibleWinWithoutTax: 0,
      possiblePayout: 0,
      possibleMinPayout: 0,
      taxOnMinWinning: 0,
      possibleWinForNumberOfHits: [],
      oddsForNumberOfHits: {}
    } as ITicketData;


    for (const sysOpt of systemOptions) {
      if (!sysOpt.optionSelected) {
        continue;
      }
      ticketData.numberOfBets += sysOpt.numberOfCombinations;
      ticketData.totalOdd += sysOpt.maxOdds;

      if (ticketData.minOdd === 1) {
        ticketData.minOdd = sysOpt.minOdds;
      } else if (ticketData.minOdd >= sysOpt.minOdds) {
        ticketData.minOdd = sysOpt.minOdds;
      }

      if (calculateOddsForNumberOfHits) {
        const keys = Object.keys(sysOpt.oddsForNumberOfHits);
        for (const key of keys) {
          if (!ticketData.oddsForNumberOfHits[+key]) {
            ticketData.oddsForNumberOfHits[+key] = { maxOdds: 0, minOdds: 0 };
          }
          ticketData.oddsForNumberOfHits[+key].maxOdds += sysOpt.oddsForNumberOfHits[key].maxOdds;
          ticketData.oddsForNumberOfHits[+key].minOdds += sysOpt.oddsForNumberOfHits[key].minOdds;
        }
      }
    }

    this.calculateOddAndWiningsTicketSystem(
      ticketData,
      ticketData.wagerPerBet,
      playerFreeBetSettings,
      playerBonussSettings,
      bonussSettings,
      freeBetBalance,
      isFix,
      orderingForTicketItemGroups,
      totalStake,
      calculateFreeBetAndBonus);

    return ticketData;
  }

  public calculateOddAndWiningsTicketSystem(
    ticketData: ITicketData,
    wagerPerBet: number,
    playerFreeBetSettings: IFreeBetSetting,
    playerBonussSettings: IBonusSettings[],
    bonussSettings: IBonusSettings[],
    freeBetBalance: number,
    isFix: boolean,
    orderingForTicketItemGroups: ITicketOrderingItem[],
    totalStake: number,
    calculateFreeBetAndBonus: boolean = true) {



    ticketData.totalWinings = ticketData.totalOdd * wagerPerBet;
    ticketData.minWinings = ticketData.minOdd * wagerPerBet;
    ticketData.totalWinings = this.utilityService.roundByBusinessModel(ticketData.totalWinings);
    ticketData.minWinings = this.utilityService.roundByBusinessModel(ticketData.minWinings);

    const maxWinnings = this.getMaxWinningsByBussinesModel(ticketData.totalStake);

    ticketData.possibleWinForNumberOfHits = [];
    for (const key in ticketData.oddsForNumberOfHits) {
      if (Object.prototype.hasOwnProperty.call(ticketData.oddsForNumberOfHits, key)) {
        const minWin = ticketData.oddsForNumberOfHits[key].minOdds * wagerPerBet;
        const maxWin = ticketData.oddsForNumberOfHits[key].maxOdds * wagerPerBet;
        const winningsPerHit: IWinningsPerHit = {
          // minWinnings: this.utilityService.roundByBusinessModel(minWin),
          // maxWinnings: this.utilityService.roundByBusinessModel(maxWin),
          // if Calculate without taxes
          minWinnings: this.calculateTaxOnWinning(this.utilityService.roundByBusinessModel(minWin), totalStake).possibleWinWithoutTax,
          maxWinnings: this.calculateTaxOnWinning(this.utilityService.roundByBusinessModel(maxWin), totalStake).possibleWinWithoutTax,
          numberOfHits: +key
        };
        if (winningsPerHit.maxWinnings > maxWinnings) {
          winningsPerHit.maxWinnings = this.calculateTaxOnWinning(this.utilityService.roundByBusinessModel(maxWinnings), totalStake).possibleWinWithoutTax;
        }

        if (winningsPerHit.minWinnings > maxWinnings) {
          winningsPerHit.minWinnings = this.calculateTaxOnWinning(this.utilityService.roundByBusinessModel(maxWinnings), totalStake).possibleWinWithoutTax;
        }
        ticketData.possibleWinForNumberOfHits.push(winningsPerHit);
      }
    }

    if (ticketData.totalWinings > maxWinnings) {
      ticketData.totalWinings = maxWinnings;
    }

    if (ticketData.minWinings > maxWinnings) {
      ticketData.minWinings = maxWinnings;
    }

    ticketData.possibleWin = ticketData.totalWinings;

    if (ticketData.numberOfBets === 1 && calculateFreeBetAndBonus) {
      const bonusValues = this.calculateBonus(playerBonussSettings, bonussSettings, totalStake, ticketData.totalOdd, ticketData.numberOfBets, ticketData.totalWinings, orderingForTicketItemGroups, wagerPerBet);
      ticketData.bonus = bonusValues.bonus;
      ticketData.bonusPercent = bonusValues.bonusPercent;
      ticketData.possibleWin = bonusValues.possibleWin;
    } else {
      ticketData.bonus = 0;
      ticketData.bonusPercent = 0;
    }

    if (calculateFreeBetAndBonus) {
      const freebets = this.calculateFreeBet(playerFreeBetSettings, freeBetBalance, ticketData.numberOfBets, orderingForTicketItemGroups, wagerPerBet, ticketData.totalOdd, ticketData.totalWinings, ticketData.bonus, totalStake);
      ticketData.freeBetValue = freebets.freeBetValue;
      ticketData.freeBetValueToShow = freebets.freeBetValueToShow;
    }

    const taxCalcResult = this.calculateTaxOnWinning(ticketData.possibleWin, totalStake);
    ticketData.taxOnWinings = taxCalcResult.taxOnWinning;
    ticketData.possibleWinWithoutTax = taxCalcResult.possibleWinWithoutTax;


    const minTaxCalculationResult = this.calculateTaxOnWinning(ticketData.minWinings, totalStake);
    ticketData.possibleMinPayout = minTaxCalculationResult.possibleWinWithoutTax;
    ticketData.taxOnMinWinning = minTaxCalculationResult.taxOnWinning;



  }

  public isTicketValid(
    orderingForTicketItemGroups: ITicketOrderingItem[],
    ticketItemGroups: { [eventId: number]: ITicketItemGroup },
    maxPayout: number,
    numOfCombinations: number,
    payin: number): boolean {

    const error: ICustomNotification = {
      message: '',
      title: DynamicTranslations.offlineBets_Error_title,
      offlineBets: [],
      restictedItems: [],
      errorLevel: ErrorLevel.Notification,
      errorType: ErrorType.Warning,
      ticket: null,
      link: null
    };

    for (const orderingItem of orderingForTicketItemGroups) {
      for (const boId of orderingItem.outcomeIds) {
        if (!this.ticketItemGroups[orderingItem.eventId].isEventPlayable || !this.ticketItemGroups[orderingItem.eventId].ticketItems[boId].isBetPlayable || !this.ticketItemGroups[orderingItem.eventId].ticketItems[boId].isBetOutcomePlayable) {
          error.offlineBets.push({
            code: this.ticketItemGroups[orderingItem.eventId].eventCode,
            name: this.ticketItemGroups[orderingItem.eventId].eventName,
            sbv: this.ticketItemGroups[orderingItem.eventId].ticketItems[boId].sbv,
            outcome: this.ticketItemGroups[orderingItem.eventId].ticketItems[boId].betOutcomeName,
            betType: this.ticketItemGroups[orderingItem.eventId].ticketItems[boId].betTypeName,
            offlineBetType: DynamicTranslations.offlineBets_Error_marketOffline
          });
        }
      }
    }

    if (error.offlineBets.length > 0) {
      error.message = DynamicTranslations.offlineBets_Error_errorMessage;
      this.notificationService.forwardDataToNotification(error);
      return false;
    }
    error.title = DynamicTranslations.ticket_Error_title_errorInTicket;

    if (numOfCombinations > ConstantValues.MAX_COMBINATIONS) {
      error.message = DynamicTranslations.ticket_Error_maxCombinations_ErrorMessage + ConstantValues.MAX_COMBINATIONS;
      this.notificationService.forwardDataToNotification(error);
      return false;
    }

    if (payin > ConstantValues.MAX_STAKE) {
      error.message = DynamicTranslations.ticket_Error_maxStake_ErrorMessage + ConstantValues.MAX_STAKE + ' ' + ConstantValues.CURRENCY;
      this.notificationService.forwardDataToNotification(error);
      return false;
    }

    if (ConstantValues.MIN_STAKE > payin) {
      error.message = DynamicTranslations.ticket_Error_minStake_ErrorMessage + ConstantValues.MIN_STAKE + ' ' + ConstantValues.CURRENCY;
      this.notificationService.forwardDataToNotification(error);
      return false;
    }

    if (ConstantValues.MIN_STAKE_PER_COMB > payin / numOfCombinations) {
      error.message = DynamicTranslations.ticket_Error_minStakePerCombination_ErrorMessage + ConstantValues.MIN_STAKE_PER_COMB + ' ' + ConstantValues.CURRENCY;
      this.notificationService.forwardDataToNotification(error);
      return false;
    }

    return true;
  }

  isTicketOnline(ticketItemGroups: { [eventId: number]: ITicketItemGroup }): boolean {
    const groupsKeys = Object.keys(ticketItemGroups);
    for (const key of groupsKeys) {
      if (!ticketItemGroups[+key].isEventPlayable) {
        return false;
        return;
      } else {
        if (Object.entries(ticketItemGroups[+key].ticketItems).map(([k, ti]) => ti).findIndex(ti => !ti.isBetOutcomePlayable || !ti.isBetPlayable || ti.odd === 1) !== -1) {

          return false;
        }
      }
    }
    return true;
  }


  public calclateTotalStake(payin: number): { totalStake: number; taxBeforeStake: number } {
    const taxBeforeStake = this.taxCalculator.calculateTaxBeforeStake(ConstantValues.TAX_DEFINITIONS?.taxBeforeStakeDefinition, payin);
    const totalStake = payin - taxBeforeStake;
    return { totalStake, taxBeforeStake };
  }


  public calculateTaxOnWinning(possibleWin: number, totalStake: number): { possibleWinWithoutTax: number; taxOnWinning: number } {
    const taxCalcResult = this.taxCalculator.calculateTaxOnWinnings(ConstantValues.TAX_DEFINITIONS?.taxOnWinningsDefinition, possibleWin, totalStake);
    const taxOnWinning = taxCalcResult.taxOnWinnings1 + taxCalcResult.taxOnWinnings2 + taxCalcResult.taxOnWinnings3 + taxCalcResult.taxOnWinnings4;
    const possibleWinWithoutTax = possibleWin - taxOnWinning;
    return { possibleWinWithoutTax, taxOnWinning };
  }

  public getFastTicket(ticketId: string) {
    this.ticketProviderService.getFastTicket(ticketId).pipe(
      switchMap(toticket => this.settingsService.getBetTypeShowTypes().pipe(
        switchMap(betTypeShowTypes => of(this.modelMapper.mapExpressTicket(toticket, betTypeShowTypes))
        )
      ))
    ).subscribe(ticket => {
      if (!ticket) {
        const notification: ICustomNotification = {
          errorLevel: ErrorLevel.Notification,
          errorType: ErrorType.CloseDialog,
          title: DynamicTranslations.notification_title,
          message: DynamicTranslations.findTicket_notFoundMessage,
        } as ICustomNotification;

        this.notificationService.forwardDataToNotification(notification);
        return;
      }
      const fixedGroupEventIds: number[] = [];
      const systemGroupEventIds: number[] = [];
      let selectedEventsInCombinations: number[] = [];
      const ticketItemGroups: { [eventId: number]: ITicketItemGroup } = {};
      for (const group of ticket.groups) {
        for (const [btoId, ticketItemFT] of Object.entries(group.ticketItems)) {
          if (group.groupType === TicketType.Fix || group.groupType === TicketType.Single) {
            if (!fixedGroupEventIds.includes(ticketItemFT.eventId)) {
              fixedGroupEventIds.push(ticketItemFT.eventId);
            }
          } else {
            if (!systemGroupEventIds.includes(ticketItemFT.eventId)) {
              systemGroupEventIds.push(ticketItemFT.eventId);
            }
          }
          if (!ticketItemGroups[ticketItemFT.eventId]) {
            ticketItemGroups[ticketItemFT.eventId] = this.modelMapper.createTicketItemGroupFromTicketItemForTicket(ticketItemFT, this.languageCulture);
          }
          ticketItemGroups[ticketItemFT.eventId].ticketItems[ticketItemFT.betOutcomeId] = this.modelMapper.createTicketItemFromTicketItemForTicket(ticketItemFT);
        }
        if (group.groupType === TicketType.System || group.groupType === TicketType.ExpandedSystem) {
          const systems: string[] = group.k.split(';');
          selectedEventsInCombinations = systems.map(s => +(s.trim()));
        }
      }

      this.addTicketItemsFromStorageOrFastTicket(ticketItemGroups, ticket.payIn, fixedGroupEventIds, systemGroupEventIds, selectedEventsInCombinations);
    });
  }
  public acceptOddsChangedAfterAddingToTicket() {
    this.changedOddsAcceptedSource.next();
  }


  createminOddsSysEvIdsByOddLowToHiWithoutBankers(ticketItemGroups: { [eventId: number]: ITicketItemGroup }, eventsInBankersGroup: number[], minOddsMap: { [eventId: number]: number }): { [eventId: number]: number } {

    // code to time here
    let minOddsSysEvIdsByOddLowToHiWithoutBankers = {};

    const allEventIds = Object.keys(ticketItemGroups);
    if (allEventIds.findIndex(eId => ticketItemGroups[+eId].isLive) > -1) {
      minOddsSysEvIdsByOddLowToHiWithoutBankers = null;
      return;
    }

    const eventIds: number[] = [];
    allEventIds.forEach(key => {
      if (!ticketItemGroups[+key].isInBankersGroup) {
        eventIds.push(+key);
      }
    });
    this.orderEventIdsByMinOddsAsc(eventIds, minOddsMap);
    let i = 0;
    eventIds.forEach(eventId => {
      i++;
      minOddsSysEvIdsByOddLowToHiWithoutBankers[eventId] = i + eventsInBankersGroup.length;
    });

    return minOddsSysEvIdsByOddLowToHiWithoutBankers;
  }

  createmaxOddsSysEvIdsByOddHiToLowWithoutBankers(ticketItemGroups: { [eventId: number]: ITicketItemGroup }, eventsInBankersGroup: number[], oddsMap: { [eventId: number]: number }): { [eventId: number]: number } {

    let maxOddsSysEvIdsByOddHiToLowWithoutBankers = {};

    const allEventIds = Object.keys(ticketItemGroups);
    if (allEventIds.findIndex(eId => ticketItemGroups[+eId].isLive) > -1) {
      maxOddsSysEvIdsByOddHiToLowWithoutBankers = null;
      return;
    }

    const eventIds: number[] = [];
    allEventIds.forEach(key => {
      if (!ticketItemGroups[+key].isInBankersGroup) {
        eventIds.push(+key);
      }
    });
    this.orderEventIdsByMaxOddsDsc(eventIds, oddsMap);
    let i = 0;
    eventIds.forEach(eventId => {
      i++;
      maxOddsSysEvIdsByOddHiToLowWithoutBankers[eventId] = i + eventsInBankersGroup.length;
    });
    return maxOddsSysEvIdsByOddHiToLowWithoutBankers;
  }

  public orderEventIdsByMinOddsAsc(eventIds: number[], minOddsMap: { [eventId: number]: number }): number[] {
    if (!eventIds || eventIds.length < 2) {
      return eventIds;
    } else {
      eventIds.sort((e1, e2) => {
        if (minOddsMap[e1] > minOddsMap[e2]) {
          return 1;
        }
        if (minOddsMap[e1] < minOddsMap[e2]) {
          return -1;
        }
        return 0;
      });
      return eventIds;
    }
  }

  public orderEventIdsByMaxOddsDsc(eventIds: number[], oddsMap: { [eventId: number]: number }): number[] {
    if (!eventIds || eventIds.length < 2) {
      return eventIds;
    } else {
      eventIds.sort((e1, e2) => {
        if (oddsMap[e1] < oddsMap[e2]) {
          return 1;
        }
        if (oddsMap[e1] > oddsMap[e2]) {
          return -1;
        }
        return 0;
      });
      return eventIds;
    }
  }

  public calculateRegularSystemOptions(ticketItemGroups: { [eventId: number]: ITicketItemGroup }, orderingForTicketItemGroups: ITicketOrderingItem[], isMultiplaySystem: boolean, systemTicketItemGroups: ITicketItemGroup[], bankerTicketItemGroups: ITicketItemGroup[]): ISystemOption[] {
    const systemOptions: ISystemOption[] = [];
    const groupList = Object.entries(ticketItemGroups).map(([k, v]) => v);
    for (let i = 0; i < orderingForTicketItemGroups.length; i++) {
      if (isMultiplaySystem) {
        systemOptions.push({
          eventsInCombination: i + 1,
          maxOdds: 0,
          minOdds: 0,
          numberOfCombinations: this.calcNumOfCombination(groupList, i + 1),
          optionSelected: false, totalNumberOfEvents: orderingForTicketItemGroups.length,
          isSuperBetConditionFulfilled: this.isSystemOptionSuperBetConditionFulfilled(i + 1, systemTicketItemGroups, bankerTicketItemGroups),
          oddsForNumberOfHits: {}
        });
      }
      else {
        systemOptions.push({
          eventsInCombination: i + 1,
          maxOdds: 0,
          minOdds: 0,
          numberOfCombinations: Math.round(Combinatorics.C(orderingForTicketItemGroups.length, i + 1)),
          optionSelected: false,
          totalNumberOfEvents: orderingForTicketItemGroups.length,
          isSuperBetConditionFulfilled: this.isSystemOptionSuperBetConditionFulfilled(i + 1, systemTicketItemGroups, bankerTicketItemGroups),
          oddsForNumberOfHits: {}
        });
      }
    }
    return systemOptions;
  }

  public calculateMultiSystemOptions(isMultiplaySystem: boolean, isMultiplayBanker: boolean, systemTicketItemGroups: ITicketItemGroup[], bankerTicketItemGroups: ITicketItemGroup[]): ISystemOption[] {
    const systemOptions: ISystemOption[] = [];
    for (let i = 0; i < systemTicketItemGroups.length; i++) {
      if (isMultiplayBanker || isMultiplaySystem) {
        systemOptions.push({
          eventsInCombination: i + 1,
          maxOdds: 0,
          minOdds: 0,
          numberOfCombinations: this.calcNumOfCombination(systemTicketItemGroups, i + 1) * this.calcNumOfCombination(bankerTicketItemGroups, bankerTicketItemGroups.length),
          optionSelected: false,
          totalNumberOfEvents: systemTicketItemGroups.length,
          isSuperBetConditionFulfilled: this.isSystemOptionSuperBetConditionFulfilled(i + 1, systemTicketItemGroups, bankerTicketItemGroups),
          oddsForNumberOfHits: {}
        });
      } else {
        systemOptions.push({
          eventsInCombination: i + 1,
          maxOdds: 0,
          minOdds: 0,
          numberOfCombinations: Math.round(Combinatorics.C(systemTicketItemGroups.length, i + 1)) * Math.round(Combinatorics.C(bankerTicketItemGroups.length, bankerTicketItemGroups.length)),
          optionSelected: false,
          totalNumberOfEvents: systemTicketItemGroups.length,
          isSuperBetConditionFulfilled: this.isSystemOptionSuperBetConditionFulfilled(i + 1, systemTicketItemGroups, bankerTicketItemGroups),
          oddsForNumberOfHits: {}
        });
      }
    }
    return systemOptions;
  }

  public calcNumOfCombination(ticketItemGroups: ITicketItemGroup[], k: number): number {
    let retVal = 0;
    const tempArray: number[] = [];
    const combinationsEvent = Combinatorics.combination<ITicketItemGroup>(ticketItemGroups, k);
    let singleCombo: ITicketItemGroup[] = [];

    while (singleCombo = combinationsEvent.next()) {
      let temp = 1;
      singleCombo.forEach(gr => {
        temp *= Object.keys(gr.ticketItems).length;
      });
      tempArray.push(temp);
    }

    retVal = tempArray.reduce((pv, cv) => pv + cv, 0);
    return retVal;
  }

  isSystemOptionSuperBetConditionFulfilled(eventsInCombination: number, systemTicketItemGroups: ITicketItemGroup[], bankerTicketItemGroups: ITicketItemGroup[]): boolean {
    const systemSuperBetEventsCount = systemTicketItemGroups.filter(g => g.mappingType === EventMappingType.SuperBetEvent).length;
    const bankersSuperBetEventsCount = bankerTicketItemGroups.filter(g => g.mappingType === EventMappingType.SuperBetEvent).length;
    if (systemSuperBetEventsCount + bankersSuperBetEventsCount < 1) {
      return true;
    }

    const bankersEventsNonSbCount = bankerTicketItemGroups.filter(g => g.mappingType !== EventMappingType.SuperBetEvent).length;

    if (bankersEventsNonSbCount >= ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS) {
      return true;
    }

    if (eventsInCombination >= ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS - bankersEventsNonSbCount + systemSuperBetEventsCount) {
      return true;
    }

    return false;

  }

  editTicketItem(ticketItemGroup: ITicketItemGroup, ticketItem: ITicketItem, editOutcome: boolean) {
    this.editTicketItemSource.next({ ticketItemGroup, ticketItem, editOutcome });
  }
}
